import React, { useEffect, useState } from "react";
import "./Requetsuserdetails.css";
import loc from "../../../../../images/locker.png";
import inn from "../../../../../images/inbox.png";
import ac from "../../../../../images/accept.png";
import de from "../../../../../images/decline.png";
import cel from "../../../../../images/clipboard.png";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  GetCommentsApplicationAction,
  GetDataApplicationAction,
  createDocApplicationAction,
  deleteApplicationAction,
} from "../../../../../redux/actions/ApplicationAction";
import ReactImageGallery from "react-image-gallery";
import { baseUrlImg } from "../../../../../Api/baseUrl";
import RightButton from "../../../../detailsproduct/RightBtn/RightBtn";
import LeftButton from "../../../../detailsproduct/LeftBtn/LeftBtn";
import { Button, Container, Modal, Spinner } from "react-bootstrap";
import { TextField } from "@mui/material";
import { ToastContainer } from "react-toastify";
import notify from "../../../../../Notifcation";
import axios from "axios";
import fileDownload from "js-file-download";
const Requetsuserdetails = () => {
  const dispatch = useDispatch();
  const [esal, seresal] = useState("");
  const [loading, setLoading] = useState(true);
  const [isPress, setisPress] = useState(false);
  const navegate = useNavigate();
  const [IDAPP, setIDAPP] = useState("");
  const [Deletesow, setDeletesow] = useState(false);
  const handleCloseDelete = () => setDeletesow(false);
  const handleShowDelete = (item) => {
    setDeletesow(true);
    setIDAPP(item);
  };

  const appdata = useSelector((state) => state.ApplicationReduser.GetdataApp);

  const Comeents = useSelector((state) => state.ApplicationReduser.Getcoments);

  const idapp = useParams();
  useEffect(() => {
    dispatch(GetCommentsApplicationAction(idapp.id));
  }, [idapp.id]);

  useEffect(() => {
    dispatch(GetDataApplicationAction(idapp.id));
    // dispatch(GetCommentsApplicationAction(idapp.id));
  }, [idapp.id]);


  const handlesubmit = async (e) => {
    e.preventDefault();
    if (esal === "") {
      notify("من فضلك اكمل البيانات المطلوبة", "error");
      return;
    }
    setisPress(true);
    const formData = new FormData();
    formData.append("payment_receipt", esal);

    formData.append("application_id", idapp.id);
    await dispatch(createDocApplicationAction(formData));
    setLoading(false);
    seresal("");
    // setfeedback('');

    setisPress(false);
  };
  const options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
  };
  const res = useSelector((state) => state.ApplicationReduser.Submitdoc);
  const del = useSelector((state) => state.ApplicationReduser.deleteApp);
  const [popup, setpopup] = useState(false);
  const [ContentFile, setContentFile] = useState("");
  const handleClosepopup = () => {
    setpopup(false);
    setpopup("");
  };
  const handleShowpopup = (item) => {
    setpopup(true);
    setContentFile(item);
  };
  const handleDownload = (url, filename) => {
    axios
      .get(url, {
        responseType: "blob",
      })
      .then((res) => {
        fileDownload(res.data, filename);
        setpopup(false);
      });
  };
  const handleDelete = async () => {
    setisPress(true);
    await dispatch(
      deleteApplicationAction(`/api/delete-application-client/`, {
        application_id: IDAPP,
      })
    );
    setDeletesow(false);
    setLoading(false);
    setisPress(false);
    setIDAPP("");
  };
  useEffect(() => {
    if (loading === false) {
      setTimeout(() => setLoading(true), 1500);
      if (res) {
        if (res.status === 201 || res.status === 200) {
          if (res.data) {
            notify(res.data.message, "success");
            dispatch(GetDataApplicationAction(idapp.id));
          }
        } else if (res.status !== 200 || res.status !== 201) {
          if (res.data) {
            notify(res.data.message, "error");
            dispatch(GetDataApplicationAction(idapp.id));
          } else {
            notify("حدثة مشكلة حاول مرة اخرى", "error");
            dispatch(GetDataApplicationAction(idapp.id));
          }
        }
      }
      if (del) {
        if (del.status === 200 || del.status === 201) {
          if (del.data) {
            notify(del.data.message, "success");
            setTimeout(() => {
              navegate("/user/requestsuser");
            }, 3000);
          }
        } else if (del.status !== 200 || del.status !== 201) {
          if (del.data) {
            notify(del.data.message, "error");
          } else {
            notify("حدثة مشكلة حاول مرة اخرى", "error");
          }
        }
      }
    }
  }, [loading]);
  return (
    <div className="bg-light text-end">
      <h4 className="text-center mb-3 mt-3">متابعة الطلب</h4>
      <div className="w-75 mx-auto bg-body-secondary d-flex flex-column">
        <div className="container w-100 p-3 bg-body-secondary">
          {appdata && appdata.car_details ? (
            <div className="row">
              <Container>
                <ReactImageGallery
                  items={appdata.car_details.car_images.map((im) => ({
                    original: baseUrlImg + im.image_url,
                  }))}
                  //   defaultImage={def}
                  showFullscreenButton={false}
                  isRTL={true}
                  showPlayButton={false}
                  showThumbnails={false}
                  renderRightNav={RightButton}
                  renderLeftNav={LeftButton}
                />
              </Container>
              <hr />
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">رقم الطلب</p>
                    <p className="card-text fw-bold">
                      {appdata.application.application_id}#
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">نوع السيارة</p>
                    <p className="card-text fw-bold">
                      {appdata.car_details.category.name}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">الموديل</p>
                    <p className="card-text fw-bold">
                      {appdata.car_details.model}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">سنة الصنع</p>
                    <p className="card-text fw-bold">
                      {appdata.car_details.year_car}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">رقم الشاسية</p>
                    <p className="card-text fw-bold">
                      {appdata.car_details.chassis_number}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">لون السيارة</p>
                    <p className="card-text fw-bold">
                      {appdata.car_details.color}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">قدرة الموتور</p>
                    <p className="card-text fw-bold">
                      {appdata.car_details.motor_number}
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">نوع الملكية</p>
                    <p className="card-text fw-bold">
                      {appdata.car_details.car_type === "F"
                        ? "اول مالك"
                        : "معاقين"}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">السعر</p>
                    <p className="card-text fw-bold">
                      {appdata.car_details.price}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">الموصفات</p>
                    <p className="card-text fw-bold">
                      {appdata.car_details.description}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75"> صورة الإيصال </p>
                    <p className="card-text fw-bold">
                      <TextField
                        label="صورة الإيصال"
                        focused
                        // inputProps={{ multiple: true }}
                        type="file"
                        onChange={(e) => seresal(e.target.files[0])}
                        variant="outlined"
                      />
                      {isPress && loading ? (
                        <button className="buttonadd">
                          <Spinner />
                        </button>
                      ) : (
                        <button className="buttonadd" onClick={handlesubmit}>
                          {" "}
                          إرسال
                        </button>
                      )}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">ملاحظات</p>
                    {Comeents && Comeents.length > 0
                      ? Comeents.map((item, idx) => (
                          <div key={idx}>
                            <p className="card-text fw-bold">
                              بواسطة : {item.username}
                            </p>
                            <p className="card-text fw-bold">{item.comment}</p>

                            <p className="card-text fw-bold">
                              منذ :{" "}
                              {new Date(item.creation_date).toLocaleString(
                                "en-US"
                              )}
                            </p>
                          </div>
                        ))
                      : null}
                  </div>
                </div>
              </div>
              {appdata.car_loan && appdata.car_loan ? (
                <div className="col-sm-6 mb-3 mb-sm-2">
                  <div className="card bg-light">
                    <div className="card-body">
                      <p className="card-title opacity-75">بيانات العميل</p>
                      <p className="card-text fw-bold">
                        نوع العميل :{" "}
                        {appdata.car_loan &&
                        appdata.car_loan.loan_type === "employee"
                          ? "موظف"
                          : appdata.car_loan &&
                            appdata.car_loan.loan_type === "pensioner"
                          ? "صاحب معاش"
                          : null}{" "}
                      </p>
                      <p className="card-text fw-bold">
                        {appdata.car_loan &&
                        appdata.car_loan.loan_type === "pensioner"
                          ? "قيمة المعاش : " + appdata.car_loan.salary
                          : appdata.car_loan &&
                            appdata.car_loan.loan_type === "employee"
                          ? "راتب الموظف : " + appdata.car_loan.salary
                          : null}
                      </p>
                      <p className="card-text fw-bold">
                        {appdata.car_loan &&
                        appdata.car_loan.type_of_use === "son"
                          ? "المستفيد : الأبن"
                          : appdata.car_loan &&
                            appdata.car_loan.type_of_use === "daughter"
                          ? "المستفيد : الأبنة"
                          : appdata.car_loan &&
                            appdata.car_loan.type_of_use === "wife"
                          ? "المستفيد : الزوجة"
                          : null}
                      </p>
                      <p className="card-text fw-bold">
                        {appdata.car_loan && appdata.car_loan.client_age !== ""
                          ? "العمر : " + appdata.car_loan.client_age
                          : appdata.car_loan &&
                            appdata.car_loan.type_of_use === "daughter"
                          ? "المستفيد : الأبنة"
                          : appdata.car_loan &&
                            appdata.car_loan.type_of_use === "wife"
                          ? "المستفيد : الزوجة"
                          : null}
                      </p>
                    </div>
                  </div>
                </div>
              ) : null}
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">الملفات</p>
                    {appdata.documents.map((doc, idx) => (
                      <p className="card-text fw-bold" key={idx}>
                        <button
                          className="buttonadd "
                          style={{ margin: "5px 0px 5px 0px" }}
                          onClick={() =>
                            handleShowpopup(baseUrlImg + doc.image)
                          }
                          // style={{ textDecoration: "none" }}
                        >
                          <i className="fa-solid fa-photo-film"></i> :{" "}
                          {doc.type === "car_contract"
                            ? "عقد السيارة"
                            : doc.type === "client_national_id"
                            ? "البطاقة الشخصية"
                            : doc.type === "payment_receipt"
                            ? "إيصال الدفع"
                            : doc.type === "guarantor_national_id"
                            ? "البطاقة الشخصية للضامن"
                            : doc.type === "salary_statement"
                            ? "بيان المرتب"
                            : doc.type === "facilities_receipt"
                            ? "إيصال المرافق"
                            : doc.type === "insurance"
                            ? "بيان التأمين"
                            : doc.type === "other"
                            ? "اخري"
                            : doc.type === "client_image"
                            ? "صور شخصية للعميل"
                            : doc.type === "military_service"
                            ? "شهادة الخدمة العسكرية"
                            : doc.type === "passport"
                            ? "جواز السفر"
                            : doc.type === "employee_statement"
                            ? "بيان حالة الموظف"
                            : doc.type === "driving_licence"
                            ? "الرخصة"
                            : doc.type === "client_national_id"
                            ? "البطاقة الشخصية"
                            : doc.type === "other"
                            ? "اخرى"
                            : doc.type === "internal_testimony_insight"
                            ? "شهادة باطنة ونظر"
                            : doc.type === "security_inquiry"
                            ? "استعلام امني"
                            : doc.type === "safety_cert"
                            ? "شهادة امان"
                            : doc.type === "driver_safety_equp"
                            ? "إيصال معدات الأمان"
                            : doc.type === "security_expenses"
                            ? "مصاريف امان"
                            : doc.type === "recored"
                            ? "المحضر"
                            : doc.type === "driving_licences"
                            ? "الرخصة"
                            : ""}
                        </button>
                      </p>
                    ))}
                  </div>
                </div>
              </div>
              {appdata.loas.length > 0 ? (
                <div className="col-sm-6 mb-3 mb-sm-2">
                  <div className="card bg-light">
                    <div className="card-body">
                      <p className="card-title opacity-75">قروض العميل</p>
                      {appdata.loas.map((item, idx) => (
                        <p key={idx} className="card-text fw-bold">
                          {" "}
                          قيمة القرض : {item.total_amount}
                        </p>
                      ))}
                    </div>
                  </div>
                </div>
              ) : null}
              <div
                style={{ color: "red", cursor: "pointer" }}
                onClick={() =>
                  handleShowDelete(appdata.application.application_id)
                }
              >
                هل تريد حذف الطلب <i className="fa-solid fa-trash-can"></i>
              </div>
            </div>
          ) : appdata && appdata.tickets ? (
            <div className="row">
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">رقم الطلب</p>
                    <p className="card-text fw-bold">
                      {appdata.application.application_id}#
                    </p>
                  </div>
                </div>
              </div>
              {appdata.tickets.from_date!==""?(
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">ذهاب</p>
                    <p className="card-text fw-bold">
                      {Intl.DateTimeFormat("ar-eg", options).format(
                        new Date(appdata.tickets.from_date)
                      )}
                    </p>
                  </div>
                </div>
              </div>
              ):null}
              {appdata.tickets.to_date!==""?(
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">عودة</p>
                    <p className="card-text fw-bold">
                      {Intl.DateTimeFormat("ar-eg", options).format(
                        new Date(appdata.tickets.to_date)
                      )}
                    </p>
                  </div>
                </div>
              </div>
              ):null}
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">الدولة من </p>
                    <p className="card-text fw-bold">
                      {appdata.tickets.from_location}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">الدولة إلى </p>
                    <p className="card-text fw-bold">
                      {appdata.tickets.to_location}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">عدد التذاكر</p>
                    <p className="card-text fw-bold">
                      {appdata.tickets.tickets_number}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">نوع التذكرة</p>
                    <p className="card-text fw-bold">
                      {appdata.tickets.ticket_type === "transient"
                        ? "ترانزيت"
                        : appdata.tickets.ticket_type === "direct"
                        ? "مباشر"
                        : null}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">صورة الإيصال</p>
                    <p className="card-text fw-bold">
                      <TextField
                        label="صورة الإيصال"
                        focused
                        // inputProps={{ multiple: true }}
                        type="file"
                        onChange={(e) => seresal(e.target.files[0])}
                        variant="outlined"
                      />
                      {isPress && loading ? (
                        <button className="buttonadd">
                          <Spinner />
                        </button>
                      ) : (
                        <button className="buttonadd" onClick={handlesubmit}>
                          {" "}
                          إرسال
                        </button>
                      )}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">ملاحظات</p>
                    {Comeents && Comeents.length > 0
                      ? Comeents.map((item, idx) => (
                          <div key={idx}>
                            <p className="card-text fw-bold">
                              بواسطة : {item.username}
                            </p>
                            <p className="card-text fw-bold">{item.comment}</p>

                            <p className="card-text fw-bold">
                              منذ :{" "}
                              {new Date(item.creation_date).toLocaleString(
                                "en-US"
                              )}
                            </p>
                          </div>
                        ))
                      : null}
                  </div>
                </div>
              </div>
              <div
                style={{ color: "red", cursor: "pointer" }}
                onClick={() =>
                  handleShowDelete(appdata.application.application_id)
                }
              >
                هل تريد حذف الطلب <i className="fa-solid fa-trash-can"></i>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">الملفات</p>
                    {appdata.documents.map((doc, idx) => (
                      <p className="card-text fw-bold" key={idx}>
                        <button
                          className="buttonadd "
                          style={{ margin: "5px 0px 5px 0px" }}
                          onClick={() =>
                            handleShowpopup(baseUrlImg + doc.image)
                          }
                          // style={{ textDecoration: "none" }}
                        >
                          <i className="fa-solid fa-photo-film"></i> :{" "}
                          {doc.type === "car_contract"
                            ? "عقد السيارة"
                            : doc.type === "client_national_id"
                            ? "البطاقة الشخصية"
                            : doc.type === "payment_receipt"
                            ? "إيصال الدفع"
                            : doc.type === "guarantor_national_id"
                            ? "البطاقة الشخصية للضامن"
                            : doc.type === "salary_statement"
                            ? "بيان المرتب"
                            : doc.type === "facilities_receipt"
                            ? "إيصال المرافق"
                            : doc.type === "insurance"
                            ? "بيان التأمين"
                            : doc.type === "other"
                            ? "اخري"
                            : doc.type === "client_image"
                            ? "صور شخصية للعميل"
                            : doc.type === "military_service"
                            ? "شهادة الخدمة العسكرية"
                            : doc.type === "passport"
                            ? "جواز السفر"
                            : doc.type === "employee_statement"
                            ? "بيان حالة الموظف"
                            : doc.type === "driving_licence"
                            ? "الرخصة"
                            : doc.type === "client_national_id"
                            ? "البطاقة الشخصية"
                            : doc.type === "other"
                            ? "اخرى"
                            : doc.type === "internal_testimony_insight"
                            ? "شهادة باطنة ونظر"
                            : doc.type === "security_inquiry"
                            ? "استعلام امني"
                            : doc.type === "safety_cert"
                            ? "شهادة امان"
                            : doc.type === "driver_safety_equp"
                            ? "إيصال معدات الأمان"
                            : doc.type === "security_expenses"
                            ? "مصاريف امان"
                            : doc.type === "recored"
                            ? "المحضر"
                            : doc.type === "driving_licences"
                            ? "الرخصة"
                            : ""}
                        </button>
                      </p>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ) : appdata && appdata.tourist_application ? (
            <div className="row">
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">رقم الطلب</p>
                    <p className="card-text fw-bold">
                      {appdata.application.application_id}#
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">نوع الحجز</p>
                    <p className="card-text fw-bold">
                      {appdata.tourist_application.type === "visa"
                        ? "فيزا "
                        : appdata.tourist_application.type === "residence"
                        ? "اقامة"
                        : null}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">الدولة</p>
                    <p className="card-text fw-bold">
                      {appdata.tourist_application.location}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">المدة</p>
                    <p className="card-text fw-bold">
                      {appdata.tourist_application.category}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">صورة الإيصال</p>
                    <p className="card-text fw-bold">
                      <TextField
                        label="صورة الإيصال"
                        focused
                        // inputProps={{ multiple: true }}
                        type="file"
                        onChange={(e) => seresal(e.target.files[0])}
                        variant="outlined"
                      />
                      {isPress && loading ? (
                        <button className="buttonadd">
                          <Spinner />
                        </button>
                      ) : (
                        <button className="buttonadd" onClick={handlesubmit}>
                          {" "}
                          إرسال
                        </button>
                      )}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">ملاحظات</p>
                    {Comeents && Comeents.length > 0
                      ? Comeents.map((item, idx) => (
                          <div key={idx}>
                            <p className="card-text fw-bold">
                              بواسطة : {item.username}
                            </p>
                            <p className="card-text fw-bold">{item.comment}</p>

                            <p className="card-text fw-bold">
                              منذ :{" "}
                              {new Date(item.creation_date).toLocaleString(
                                "en-US"
                              )}
                            </p>
                          </div>
                        ))
                      : null}
                  </div>
                </div>
              </div>
              <div
                style={{ color: "red", cursor: "pointer" }}
                onClick={() =>
                  handleShowDelete(appdata.application.application_id)
                }
              >
                هل تريد حذف الطلب <i className="fa-solid fa-trash-can"></i>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">الملفات</p>
                    {appdata.documents.map((doc, idx) => (
                      <p className="card-text fw-bold" key={idx}>
                        <button
                          className="buttonadd "
                          style={{ margin: "5px 0px 5px 0px" }}
                          onClick={() =>
                            handleShowpopup(baseUrlImg + doc.image)
                          }
                          // style={{ textDecoration: "none" }}
                        >
                          <i className="fa-solid fa-photo-film"></i> :{" "}
                          {doc.type === "car_contract"
                            ? "عقد السيارة"
                            : doc.type === "client_national_id"
                            ? "البطاقة الشخصية"
                            : doc.type === "payment_receipt"
                            ? "إيصال الدفع"
                            : doc.type === "guarantor_national_id"
                            ? "البطاقة الشخصية للضامن"
                            : doc.type === "salary_statement"
                            ? "بيان المرتب"
                            : doc.type === "facilities_receipt"
                            ? "إيصال المرافق"
                            : doc.type === "insurance"
                            ? "بيان التأمين"
                            : doc.type === "other"
                            ? "اخري"
                            : doc.type === "client_image"
                            ? "صور شخصية للعميل"
                            : doc.type === "military_service"
                            ? "شهادة الخدمة العسكرية"
                            : doc.type === "passport"
                            ? "جواز السفر"
                            : doc.type === "employee_statement"
                            ? "بيان حالة الموظف"
                            : doc.type === "driving_licence"
                            ? "الرخصة"
                            : doc.type === "client_national_id"
                            ? "البطاقة الشخصية"
                            : doc.type === "other"
                            ? "اخرى"
                            : doc.type === "internal_testimony_insight"
                            ? "شهادة باطنة ونظر"
                            : doc.type === "security_inquiry"
                            ? "استعلام امني"
                            : doc.type === "safety_cert"
                            ? "شهادة امان"
                            : doc.type === "driver_safety_equp"
                            ? "إيصال معدات الأمان"
                            : doc.type === "security_expenses"
                            ? "مصاريف امان"
                            : doc.type === "recored"
                            ? "المحضر"
                            : doc.type === "driving_licences"
                            ? "الرخصة"
                            : ""}
                        </button>
                      </p>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ) : appdata &&
            appdata.traffic_services &&
            appdata.traffic_services.category === 1 ? (
            <div className="row">
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">رقم الطلب</p>
                    <p className="card-text fw-bold">
                      {appdata.application.application_id}#
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">نوع الطلب</p>
                    <p className="card-text fw-bold">
                      {appdata.traffic_services.category === 1
                        ? "افراد"
                        : appdata.traffic_services.category === 2
                        ? "سيارات"
                        : null}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">نوع الخدمة</p>
                    <p className="card-text fw-bold">
                      {appdata.traffic_services.type === "new"
                        ? "استخراج رخصة جديدة"
                        : appdata.traffic_services.type === "renewal"
                        ? "تجديد رخصة"
                        : appdata.traffic_services.type === "instead"
                        ? "بدل فاقد"
                        : null}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">الأسم</p>
                    <p className="card-text fw-bold">
                      {
                        appdata.traffic_services.application_details.client_data
                          .name
                      }
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">الرقم القومي</p>
                    <p className="card-text fw-bold">
                      {
                        appdata.traffic_services.application_details.client_data
                          .national_id
                      }
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">تفاصيل</p>
                    <p className="card-text fw-bold">
                      {
                        appdata.traffic_services.application_details.client_data
                          .details
                      }
                    </p>
                  </div>
                </div>
              </div>
              {appdata.traffic_services.application_details.client_data
                .licence_du_date !== null ? (
                <div className="col-sm-6 mb-3 mb-sm-2">
                  <div className="card bg-light">
                    <div className="card-body">
                      <p className="card-title opacity-75">
                        تاريخ انتهاء الرخصة
                      </p>
                      <p className="card-text fw-bold">
                        {
                          appdata.traffic_services.application_details
                            .client_data.licence_du_date
                        }
                      </p>
                    </div>
                  </div>
                </div>
              ) : null}
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">صورة الإيصال</p>
                    <p className="card-text fw-bold">
                      <TextField
                        label="صورة الإيصال"
                        focused
                        // inputProps={{ multiple: true }}
                        type="file"
                        onChange={(e) => seresal(e.target.files[0])}
                        variant="outlined"
                      />
                      {isPress && loading ? (
                        <button className="buttonadd">
                          <Spinner />
                        </button>
                      ) : (
                        <button className="buttonadd" onClick={handlesubmit}>
                          {" "}
                          إرسال
                        </button>
                      )}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">ملاحظات</p>
                    {Comeents && Comeents.length > 0
                      ? Comeents.map((item, idx) => (
                          <div key={idx}>
                            <p className="card-text fw-bold">
                              بواسطة : {item.username}
                            </p>
                            <p className="card-text fw-bold">{item.comment}</p>

                            <p className="card-text fw-bold">
                              منذ :{" "}
                              {new Date(item.creation_date).toLocaleString(
                                "en-US"
                              )}
                            </p>
                          </div>
                        ))
                      : null}
                  </div>
                </div>
              </div>
              <div
                style={{ color: "red", cursor: "pointer" }}
                onClick={() =>
                  handleShowDelete(appdata.application.application_id)
                }
              >
                هل تريد حذف الطلب <i className="fa-solid fa-trash-can"></i>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">الملفات</p>
                    {appdata.documents.map((doc, idx) => (
                      <p className="card-text fw-bold" key={idx}>
                        <button
                          className="buttonadd "
                          style={{ margin: "5px 0px 5px 0px" }}
                          onClick={() =>
                            handleShowpopup(baseUrlImg + doc.image)
                          }
                          // style={{ textDecoration: "none" }}
                        >
                          <i className="fa-solid fa-photo-film"></i> :{" "}
                          {doc.type === "car_contract"
                            ? "عقد السيارة"
                            : doc.type === "client_national_id"
                            ? "البطاقة الشخصية"
                            : doc.type === "payment_receipt"
                            ? "إيصال الدفع"
                            : doc.type === "guarantor_national_id"
                            ? "البطاقة الشخصية للضامن"
                            : doc.type === "salary_statement"
                            ? "بيان المرتب"
                            : doc.type === "facilities_receipt"
                            ? "إيصال المرافق"
                            : doc.type === "insurance"
                            ? "بيان التأمين"
                            : doc.type === "other"
                            ? "اخري"
                            : doc.type === "client_image"
                            ? "صور شخصية للعميل"
                            : doc.type === "military_service"
                            ? "شهادة الخدمة العسكرية"
                            : doc.type === "passport"
                            ? "جواز السفر"
                            : doc.type === "employee_statement"
                            ? "بيان حالة الموظف"
                            : doc.type === "driving_licence"
                            ? "الرخصة"
                            : doc.type === "client_national_id"
                            ? "البطاقة الشخصية"
                            : doc.type === "other"
                            ? "اخرى"
                            : doc.type === "internal_testimony_insight"
                            ? "شهادة باطنة ونظر"
                            : doc.type === "security_inquiry"
                            ? "استعلام امني"
                            : doc.type === "safety_cert"
                            ? "شهادة امان"
                            : doc.type === "driver_safety_equp"
                            ? "إيصال معدات الأمان"
                            : doc.type === "security_expenses"
                            ? "مصاريف امان"
                            : doc.type === "recored"
                            ? "المحضر"
                            : doc.type === "driving_licences"
                            ? "الرخصة"
                            : ""}
                        </button>
                      </p>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ) : appdata &&
            appdata.traffic_services &&
            appdata.traffic_services.category === 2 ? (
            <div className="row">
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">رقم الطلب</p>
                    <p className="card-text fw-bold">
                      {appdata.application.application_id}#
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">نوع الطلب</p>
                    <p className="card-text fw-bold">
                      {appdata.traffic_services.category === 1
                        ? "افراد"
                        : appdata.traffic_services.category === 2
                        ? "سيارات"
                        : null}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">نوع الخدمة</p>
                    <p className="card-text fw-bold">
                      {appdata.traffic_services.type === "new"
                        ? "استخراج رخصة جديدة"
                        : appdata.traffic_services.type === "renewal"
                        ? "تجديد رخصة"
                        : appdata.traffic_services.type === "instead"
                        ? "بدل فاقد"
                        : null}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">الأسم</p>
                    <p className="card-text fw-bold">
                      {
                        appdata.traffic_services.application_details.car_details
                          .client_name
                      }
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">الرقم القومي</p>
                    <p className="card-text fw-bold">
                      {
                        appdata.traffic_services.application_details.car_details
                          .national_id
                      }
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">نوع السيارة</p>
                    <p className="card-text fw-bold">
                      {
                        appdata.traffic_services.application_details.car_details
                          .car_type
                      }
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">موديل السيارة</p>
                    <p className="card-text fw-bold">
                      {
                        appdata.traffic_services.application_details.car_details
                          .model
                      }
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">سنة الصنع</p>
                    <p className="card-text fw-bold">
                      {
                        appdata.traffic_services.application_details.car_details
                          .year_car
                      }
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">قدرة الموتور</p>
                    <p className="card-text fw-bold">
                      {
                        appdata.traffic_services.application_details.car_details
                          .motor_number
                      }
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">رقم الشاسية</p>
                    <p className="card-text fw-bold">
                      {
                        appdata.traffic_services.application_details.car_details
                          .chassis_number
                      }
                    </p>
                  </div>
                </div>
              </div>
              {appdata.traffic_services.application_details.car_details
                .licence_due_date !== null ? (
                <div className="col-sm-6 mb-3 mb-sm-2">
                  <div className="card bg-light">
                    <div className="card-body">
                      <p className="card-title opacity-75">
                        تاريخ انتهاء الرخصة
                      </p>
                      <p className="card-text fw-bold">
                        {
                          appdata.traffic_services.application_details
                            .car_details.licence_due_date
                        }
                      </p>
                    </div>
                  </div>
                </div>
              ) : null}
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">تفاصيل</p>
                    <p className="card-text fw-bold">
                      {
                        appdata.traffic_services.application_details.car_details
                          .details
                      }
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">صورة الإيصال</p>
                    <p className="card-text fw-bold">
                      <TextField
                        label="صورة الإيصال"
                        focused
                        // inputProps={{ multiple: true }}
                        type="file"
                        onChange={(e) => seresal(e.target.files[0])}
                        variant="outlined"
                      />
                      {isPress && loading ? (
                        <button className="buttonadd">
                          <Spinner />
                        </button>
                      ) : (
                        <button className="buttonadd" onClick={handlesubmit}>
                          {" "}
                          إرسال
                        </button>
                      )}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">ملاحظات</p>
                    {Comeents && Comeents.length > 0
                      ? Comeents.map((item, idx) => (
                          <div key={idx}>
                            <p className="card-text fw-bold">
                              بواسطة : {item.username}
                            </p>
                            <p className="card-text fw-bold">{item.comment}</p>

                            <p className="card-text fw-bold">
                              منذ :{" "}
                              {new Date(item.creation_date).toLocaleString(
                                "en-US"
                              )}
                            </p>
                          </div>
                        ))
                      : null}
                  </div>
                </div>
              </div>
              <div
                style={{ color: "red", cursor: "pointer" }}
                onClick={() =>
                  handleShowDelete(appdata.application.application_id)
                }
              >
                هل تريد حذف الطلب <i className="fa-solid fa-trash-can"></i>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">الملفات</p>
                    {appdata.documents.map((doc, idx) => (
                      <p className="card-text fw-bold" key={idx}>
                        <button
                          className="buttonadd "
                          style={{ margin: "5px 0px 5px 0px" }}
                          onClick={() =>
                            handleShowpopup(baseUrlImg + doc.image)
                          }
                          // style={{ textDecoration: "none" }}
                        >
                          <i className="fa-solid fa-photo-film"></i> :{" "}
                          {doc.type === "car_contract"
                            ? "عقد السيارة"
                            : doc.type === "client_national_id"
                            ? "البطاقة الشخصية"
                            : doc.type === "payment_receipt"
                            ? "إيصال الدفع"
                            : doc.type === "guarantor_national_id"
                            ? "البطاقة الشخصية للضامن"
                            : doc.type === "salary_statement"
                            ? "بيان المرتب"
                            : doc.type === "facilities_receipt"
                            ? "إيصال المرافق"
                            : doc.type === "insurance"
                            ? "بيان التأمين"
                            : doc.type === "other"
                            ? "اخري"
                            : doc.type === "client_image"
                            ? "صور شخصية للعميل"
                            : doc.type === "military_service"
                            ? "شهادة الخدمة العسكرية"
                            : doc.type === "passport"
                            ? "جواز السفر"
                            : doc.type === "employee_statement"
                            ? "بيان حالة الموظف"
                            : doc.type === "driving_licence"
                            ? "الرخصة"
                            : doc.type === "client_national_id"
                            ? "البطاقة الشخصية"
                            : doc.type === "other"
                            ? "اخرى"
                            : doc.type === "internal_testimony_insight"
                            ? "شهادة باطنة ونظر"
                            : doc.type === "security_inquiry"
                            ? "استعلام امني"
                            : doc.type === "safety_cert"
                            ? "شهادة امان"
                            : doc.type === "driver_safety_equp"
                            ? "إيصال معدات الأمان"
                            : doc.type === "security_expenses"
                            ? "مصاريف امان"
                            : doc.type === "recored"
                            ? "المحضر"
                            : doc.type === "driving_licences"
                            ? "الرخصة"
                            : ""}
                        </button>
                      </p>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ) : appdata && appdata.realestate ? (
            <div className="row">
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">رقم الطلب</p>
                    <p className="card-text fw-bold">
                      {appdata.application.application_id}#
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">نوع الخدمة</p>
                    <p className="card-text fw-bold">
                      {appdata.realestate.category === 1
                        ? "أعمال التوكيلات"
                        : appdata.realestate.category === 2
                        ? "طلب الأستخراج"
                        : appdata.realestate.category === 3
                        ? "أعمال التحرير والتوثيق"
                        : null}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">نوع الطلب</p>
                    <p className="card-text fw-bold">
                      {appdata.realestate.type === 1
                        ? "تحرير توكيل عام قضايا"
                        : appdata.realestate.type === 2
                        ? "تحرير اقرار بالشطب"
                        : appdata.realestate.type === 3
                        ? "تحرير بعدم وجود تعديل على البيانات المساحية"
                        : appdata.realestate.type === 4
                        ? "تحرير اقرار رسمي"
                        : appdata.realestate.type === 5
                        ? "تحرير توكيل رسمي"
                        : appdata.realestate.type === 6
                        ? "تحرير توكيل رسمي شامل بنوك"
                        : appdata.realestate.type === 7
                        ? "تحرير توكيل قضايا"
                        : appdata.realestate.type === 8
                        ? "تحرير توكيل في الامور الزوجية"
                        : appdata.realestate.type === 9
                        ? "توكيل في الامور الزوجية"
                        : appdata.realestate.type === 10
                        ? "توكيل رسمي عام"
                        : appdata.realestate.type === 11
                        ? "توكيل عام قضايا"
                        : appdata.realestate.type === 12
                        ? "توكيل خاص"
                        : appdata.realestate.type === 13
                        ? "توكيل شامل"
                        : appdata.realestate.type === 14
                        ? "صورة من عقد مشهر"
                        : appdata.realestate.type === 15
                        ? "صورة من كتاب دوري"
                        : appdata.realestate.type === 16
                        ? "صورة من منشور فني"
                        : appdata.realestate.type === 17
                        ? "صورة من منشور مالي"
                        : appdata.realestate.type === 18
                        ? "شهادة تصرفات عقاري"
                        : null}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">تفاصيل</p>
                    <p className="card-text fw-bold">
                      {appdata.realestate.details}
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">صورة الإيصال</p>
                    <p className="card-text fw-bold">
                      <TextField
                        label="صورة الإيصال"
                        focused
                        // inputProps={{ multiple: true }}
                        type="file"
                        onChange={(e) => seresal(e.target.files[0])}
                        variant="outlined"
                      />
                      {isPress && loading ? (
                        <button className="buttonadd">
                          <Spinner />
                        </button>
                      ) : (
                        <button className="buttonadd" onClick={handlesubmit}>
                          {" "}
                          إرسال
                        </button>
                      )}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">ملاحظات</p>
                    {Comeents && Comeents.length > 0
                      ? Comeents.map((item, idx) => (
                          <div key={idx}>
                            <p className="card-text fw-bold">
                              بواسطة : {item.username}
                            </p>
                            <p className="card-text fw-bold">{item.comment}</p>

                            <p className="card-text fw-bold">
                              منذ :{" "}
                              {new Date(item.creation_date).toLocaleString(
                                "en-US"
                              )}
                            </p>
                          </div>
                        ))
                      : null}
                  </div>
                </div>
              </div>
              <div
                style={{ color: "red", cursor: "pointer" }}
                onClick={() =>
                  handleShowDelete(appdata.application.application_id)
                }
              >
                هل تريد حذف الطلب <i className="fa-solid fa-trash-can"></i>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">الملفات</p>
                    {appdata.documents.map((doc, idx) => (
                      <p className="card-text fw-bold" key={idx}>
                        <button
                          className="buttonadd "
                          style={{ margin: "5px 0px 5px 0px" }}
                          onClick={() =>
                            handleShowpopup(baseUrlImg + doc.image)
                          }
                          // style={{ textDecoration: "none" }}
                        >
                          <i className="fa-solid fa-photo-film"></i> :{" "}
                          {doc.type === "car_contract"
                            ? "عقد السيارة"
                            : doc.type === "client_national_id"
                            ? "البطاقة الشخصية"
                            : doc.type === "payment_receipt"
                            ? "إيصال الدفع"
                            : doc.type === "guarantor_national_id"
                            ? "البطاقة الشخصية للضامن"
                            : doc.type === "salary_statement"
                            ? "بيان المرتب"
                            : doc.type === "facilities_receipt"
                            ? "إيصال المرافق"
                            : doc.type === "insurance"
                            ? "بيان التأمين"
                            : doc.type === "other"
                            ? "اخري"
                            : doc.type === "client_image"
                            ? "صور شخصية للعميل"
                            : doc.type === "military_service"
                            ? "شهادة الخدمة العسكرية"
                            : doc.type === "passport"
                            ? "جواز السفر"
                            : doc.type === "employee_statement"
                            ? "بيان حالة الموظف"
                            : doc.type === "driving_licence"
                            ? "الرخصة"
                            : doc.type === "client_national_id"
                            ? "البطاقة الشخصية"
                            : doc.type === "other"
                            ? "اخرى"
                            : doc.type === "internal_testimony_insight"
                            ? "شهادة باطنة ونظر"
                            : doc.type === "security_inquiry"
                            ? "استعلام امني"
                            : doc.type === "safety_cert"
                            ? "شهادة امان"
                            : doc.type === "driver_safety_equp"
                            ? "إيصال معدات الأمان"
                            : doc.type === "security_expenses"
                            ? "مصاريف امان"
                            : doc.type === "recored"
                            ? "المحضر"
                            : doc.type === "driving_licences"
                            ? "الرخصة"
                            : ""}
                        </button>
                      </p>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ) : appdata &&
            appdata.local_services &&
            appdata.local_services.type === 1 ? (
            <div className="row">
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">رقم الطلب</p>
                    <p className="card-text fw-bold">
                      {appdata.application.application_id}#
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">نوع الطلب</p>
                    <p className="card-text fw-bold">خدمات البناء</p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">نوع الخدمة</p>
                    <p className="card-text fw-bold">
                      {appdata.local_services.category === 1
                        ? "خدمة استخراج تراخيص البناء"
                        : appdata.local_services.category === 2
                        ? "طلب استخراج بيان بصلاحية الموقع من الناحية التخطيطية"
                        : appdata.local_services.category === 3
                        ? "طلب قيد اتحاد شاغلين"
                        : appdata.local_services.category === 4
                        ? "طلب معاينة عقارات آيلة للسقوط"
                        : appdata.local_services.category === 5
                        ? "طلب خدمة الحصول على قرار هدم منشأة آيلة للسقوط"
                        : appdata.local_services.category === 6
                        ? "طلب خدمة الحصول على ترميم منشأة آيلة للسقوط"
                        : appdata.local_services.category === 7
                        ? "طلب شهادة باتمام خدمة الترميم"
                        : null}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">الأجراء</p>
                    <p className="card-text fw-bold">
                      {appdata.local_services.type_details === "construction"
                        ? "انشاء"
                        : appdata.local_services.type_details === "amendment"
                        ? "تعديل"
                        : appdata.local_services.type_details ===
                          "external_finishes"
                        ? "تشطيبات خارجية"
                        : appdata.local_services.type_details === "addition"
                        ? "اضافة"
                        : appdata.local_services.type_details === "complete"
                        ? "استكمال"
                        : appdata.local_services.type_details === "raising"
                        ? "تعلية"
                        : null}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">تفاصيل</p>
                    <p className="card-text fw-bold">
                      {appdata.local_services.details}
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">صورة الإيصال</p>
                    <p className="card-text fw-bold">
                      <TextField
                        label="صورة الإيصال"
                        focused
                        // inputProps={{ multiple: true }}
                        type="file"
                        onChange={(e) => seresal(e.target.files[0])}
                        variant="outlined"
                      />
                      {isPress && loading ? (
                        <button className="buttonadd">
                          <Spinner />
                        </button>
                      ) : (
                        <button className="buttonadd" onClick={handlesubmit}>
                          {" "}
                          إرسال
                        </button>
                      )}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">ملاحظات</p>
                    {Comeents && Comeents.length > 0
                      ? Comeents.map((item, idx) => (
                          <div key={idx}>
                            <p className="card-text fw-bold">
                              بواسطة : {item.username}
                            </p>
                            <p className="card-text fw-bold">{item.comment}</p>

                            <p className="card-text fw-bold">
                              منذ :{" "}
                              {new Date(item.creation_date).toLocaleString(
                                "en-US"
                              )}
                            </p>
                          </div>
                        ))
                      : null}
                  </div>
                </div>
              </div>
              <div
                style={{ color: "red", cursor: "pointer" }}
                onClick={() =>
                  handleShowDelete(appdata.application.application_id)
                }
              >
                هل تريد حذف الطلب <i className="fa-solid fa-trash-can"></i>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">الملفات</p>
                    {appdata.documents.map((doc, idx) => (
                      <p className="card-text fw-bold" key={idx}>
                        <button
                          className="buttonadd "
                          style={{ margin: "5px 0px 5px 0px" }}
                          onClick={() =>
                            handleShowpopup(baseUrlImg + doc.image)
                          }
                          // style={{ textDecoration: "none" }}
                        >
                          <i className="fa-solid fa-photo-film"></i> :{" "}
                          {doc.type === "official_extract_commercial_register"
                            ? "مستخرج رسمي من السجل التجاري"
                            : doc.type ===
                              "certificate_registration_relevant_chamber"
                            ? "صورة شهادة قيد بالغرفة المختصة"
                            : doc.type === "tax_card"
                            ? "صورة من البطاقة الضريبية"
                            : doc.type ===
                              "document_exploitation_location_place"
                            ? "سند استغلال موقع الأعلان"
                            : doc.type === "title_deed"
                            ? "سند ملكية الأرض"
                            : doc.type === "cost_calculation_form"
                            ? "نموزج حساب التكاليف"
                            : doc.type === "insurance_policy"
                            ? "وثيقة تأمين "
                            : doc.type === "business_validity_certificate"
                            ? "شهادة صلاحية الأعمال للتراخيص موقعة من المهندس"
                            : doc.type ===
                              "insurance_document_construction_drawings"
                            ? "وثيقة تأمين بها نسبة من الرسومات الأنشائية معتمدة من المحطة العشرية"
                            : doc.type === "detect_recorders"
                            ? "كشف مسجلات لأكثر من عامين"
                            : doc.type === "property_picture"
                            ? "صورة للعقار"
                            : doc.type === "tax_certificate"
                            ? "شهادة من مأمورية الضرائب"
                            : doc.type ===
                              "final_decision_administrative_authority_demolish"
                            ? "قرار نهائي من الجهة الأدارية بالهدم"
                            : doc.type === "elevator_installation_contract"
                            ? "عقد تركيب المصعد من احد الشركات مع صورة من تصريح مزاولة المهنة "
                            : doc.type ===
                              "elevator_company_registration_classification_card"
                            ? "صورة من بطاقة قيد وتصنيف شركة المصاعد بالأتحاد المصري لمقاولي التنفيذ والبناء"
                            : doc.type ===
                              "technical_engineering_specifications_file"
                            ? "ملف الموصفات الفنية والرسومات الهندسية"
                            : doc.type === "assessment_includes_business"
                            ? "مقاييس تتضمن الأعمال"
                            : doc.type === "arithmetic_note"
                            ? "نوتة حسابية من مكتب المهندس"
                            : doc.type === "structural_engineer_report"
                            ? "تقرير مهندس انشائي "
                            : doc.type === "license_application"
                            ? "طلب الترخيص"
                            : doc.type === "lease"
                            ? "صورة من مستند الايجار ساري لمدة مناسبة وموضح النشاط"
                            : doc.type === "ownership_contract"
                            ? "صورة من مستند الملكية ساري لمدة مناسبة وموضح النشاط"
                            : doc.type === "construction_license"
                            ? "صورة من رخصة البناء"
                            : doc.type === "organization_benefit_store_position"
                            ? "افادة من التنظيم بموقف المحل (رخصة - تقنين)"
                            : doc.type ===
                              "real_estate_transactions_certificate"
                            ? "شهادة تصرف عقاري"
                            : doc.type === "certified_engineering_report"
                            ? "تقرير هندسي معتمد يثبت السلامة الأنشائية"
                            : doc.type === "sketch_showing_location"
                            ? "الرسم الكروكي"
                            : doc.type === "power_attoreny"
                            ? "التوكيل"
                            : doc.type === "original_license"
                            ? "اصل الرخصة"
                            : doc.type === "payment_receipt"
                            ? "إيصال الدفع"
                            : doc.type === "criminal_record"
                            ? "صحيفة الحالة الجنائية"
                            : doc.type === "assignment_contract"
                            ? "عقد التنازل ومصدق من الشهر العقاري"
                            : doc.type === "benefits_assignee_insurance"
                            ? "ما يفيد المتنازل الية بالتأمينات"
                            : doc.type === "military_service"
                            ? "الموقف من التجنيد"
                            : doc.type ===
                              "construction_drawings_advertising_stands"
                            ? "نسختان من الرسومات الأنشائية للحوامل بالأعلان"
                            : doc.type ===
                              "drawings_electrical_installations_connections"
                            ? "نسختان من الرسومات للتركيبات و للتوصيلات الكهربائية "
                            : doc.type === "passport"
                            ? "جواز السفر"
                            : doc.type === "engineering_drawings"
                            ? "الرسومات الهندسية"
                            : doc.type === "client_national_id"
                            ? "البطاقة الشخصية"
                            : doc.type === "health_certificate_employees"
                            ? "شهادة صحية لجميع العاملين"
                            : doc.type === "other"
                            ? "ملفات اخرى"
                            : ""}
                        </button>
                      </p>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ) : appdata &&
            appdata.local_services &&
            appdata.local_services.type === 2 ? (
            <div className="row">
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">رقم الطلب</p>
                    <p className="card-text fw-bold">
                      {appdata.application.application_id}#
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">نوع الطلب</p>
                    <p className="card-text fw-bold">خدمات الأراضي</p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">نوع الخدمة</p>
                    <p className="card-text fw-bold">
            { appdata.local_services.category===34?'طلب استلام قطعة ارض (الأراضي الحديثة -افراد )':
              appdata.local_services.category===35?'طلب اعادة تحديد الأراضي (الأراضي الحديثة -افراد )':
              appdata.local_services.category===36?'طلب استخراج عقد نهائي لأرض مسددة القيمةبالكامل (الأراضي الحديثة -افراد )':
              appdata.local_services.category===37?'طلب ضم قطعة ارض (الأراضي الحديثة -افراد )':
              appdata.local_services.category===38?'طلب بيان صلاحية الموقع (الأراضي الحديثة -افراد )':

              appdata.local_services.category===39?'طلب اعادة معاينة باختلاف المساحة (الأراضي القديمة -افراد )':
              appdata.local_services.category===40?'طلب تخصيص الأرض (الأراضي القديمة -افراد )':
              appdata.local_services.category===41?'طلب تغير تخصيخ باسم الورثة (الأراضي القديمة -افراد )':
              appdata.local_services.category===42?'طلب بيان مساحي عن قطعة ارض (الأراضي القديمة -افراد )':

              appdata.local_services.category===43?'طلب تقسيط ثمن ارض (طلبات مالية -افراد )':
              appdata.local_services.category===44?'طلب مراجعة متأخرات الأقساط على الأرض (طلبات مالية -افراد )':
              appdata.local_services.category===45?'طلب تقسيط متأخرات عن المديونية (طلبات مالية -افراد )':

              appdata.local_services.category===46?'طلب تعديل الكيان القانوني (الأسم -شركات )':
              appdata.local_services.category===47?'طلب تعديل الكيان القانوني (اضافة شريك -شركات )':
              appdata.local_services.category===48?'طلب تعديل الكيان القانوني (تنازل عن الأرض للشركاء -شركات )':
              appdata.local_services.category===49?'طلب تعديل الكيان القانوني (تنازل لشركة اخرى -شركات )':
              appdata.local_services.category===50?'طلب تغير استخدام الأراضي (شركات)':

              appdata.local_services.category===51?' طلب تقسيط المديونية لأراضي الأستثمار (طلبات مالية - شركات )':null}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">تفاصيل</p>
                    <p className="card-text fw-bold">
                      {appdata.local_services.details}
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">صورة الإيصال</p>
                    <p className="card-text fw-bold">
                      <TextField
                        label="صورة الإيصال"
                        focused
                        // inputProps={{ multiple: true }}
                        type="file"
                        onChange={(e) => seresal(e.target.files[0])}
                        variant="outlined"
                      />
                      {isPress && loading ? (
                        <button className="buttonadd">
                          <Spinner />
                        </button>
                      ) : (
                        <button className="buttonadd" onClick={handlesubmit}>
                          {" "}
                          إرسال
                        </button>
                      )}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">ملاحظات</p>
                    {Comeents && Comeents.length > 0
                      ? Comeents.map((item, idx) => (
                          <div key={idx}>
                            <p className="card-text fw-bold">
                              بواسطة : {item.username}
                            </p>
                            <p className="card-text fw-bold">{item.comment}</p>

                            <p className="card-text fw-bold">
                              منذ :{" "}
                              {new Date(item.creation_date).toLocaleString(
                                "en-US"
                              )}
                            </p>
                          </div>
                        ))
                      : null}
                  </div>
                </div>
              </div>
              <div
                style={{ color: "red", cursor: "pointer" }}
                onClick={() =>
                  handleShowDelete(appdata.application.application_id)
                }
              >
                هل تريد حذف الطلب <i className="fa-solid fa-trash-can"></i>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">الملفات</p>
                    {appdata.documents.map((doc, idx) => (
                      <p className="card-text fw-bold" key={idx}>
                        <button
                          className="buttonadd "
                          style={{ margin: "5px 0px 5px 0px" }}
                          onClick={() =>
                            handleShowpopup(baseUrlImg + doc.image)
                          }
                          // style={{ textDecoration: "none" }}
                        >
                          <i className="fa-solid fa-photo-film"></i> :{" "}
                          {
                             doc.type === "license_application"
                            ? "طلب الترخيص"
                            : doc.type === "payment_receipt"
                            ? "إيصال الدفع"
                           
                            : doc.type === "client_national_id"
                            ? "البطاقة الشخصية"
    
                            : doc.type === "other"
                            ? "ملفات اخرى"
                            : ""}
                        </button>
                      </p>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ) : appdata &&
            appdata.local_services &&
            appdata.local_services.type === 3 ? (
            <div className="row">
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">رقم الطلب</p>
                    <p className="card-text fw-bold">
                      {appdata.application.application_id}#
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">نوع الطلب</p>
                    <p className="card-text fw-bold">خدمات الأشغالات</p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">نوع الخدمة</p>
                    <p className="card-text fw-bold">
                      {appdata.local_services.category === 11
                        ? "طلب ترخيص اشغال طريق"
                        : appdata.local_services.category === 12
                        ? "طلب نقل رخصة اشغال طريق"
                        : appdata.local_services.category === 13
                        ? "طلب الغاء رخصة اشغال طريق"
                        : appdata.local_services.category === 31
                        ? "طلب تجديد رخصة اشغال طريق"
                        : appdata.local_services.category === 32
                        ? "طلب استرداد مضبوطات اشغال طريق"
                        : appdata.local_services.category === 33
                        ? " طلب استخراج ما يفيد سداد مخالفات اشغال الطريق"
                        : ""}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">تفاصيل</p>
                    <p className="card-text fw-bold">
                      {appdata.local_services.details}
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">صورة الإيصال</p>
                    <p className="card-text fw-bold">
                      <TextField
                        label="صورة الإيصال"
                        focused
                        // inputProps={{ multiple: true }}
                        type="file"
                        onChange={(e) => seresal(e.target.files[0])}
                        variant="outlined"
                      />
                      {isPress && loading ? (
                        <button className="buttonadd">
                          <Spinner />
                        </button>
                      ) : (
                        <button className="buttonadd" onClick={handlesubmit}>
                          {" "}
                          إرسال
                        </button>
                      )}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">ملاحظات</p>
                    {Comeents && Comeents.length > 0
                      ? Comeents.map((item, idx) => (
                          <div key={idx}>
                            <p className="card-text fw-bold">
                              بواسطة : {item.username}
                            </p>
                            <p className="card-text fw-bold">{item.comment}</p>

                            <p className="card-text fw-bold">
                              منذ :{" "}
                              {new Date(item.creation_date).toLocaleString(
                                "en-US"
                              )}
                            </p>
                          </div>
                        ))
                      : null}
                  </div>
                </div>
              </div>
              <div
                style={{ color: "red", cursor: "pointer" }}
                onClick={() =>
                  handleShowDelete(appdata.application.application_id)
                }
              >
                هل تريد حذف الطلب <i className="fa-solid fa-trash-can"></i>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">الملفات</p>
                    {appdata.documents.map((doc, idx) => (
                      <p className="card-text fw-bold" key={idx}>
                        <button
                          className="buttonadd "
                          style={{ margin: "5px 0px 5px 0px" }}
                          onClick={() =>
                            handleShowpopup(baseUrlImg + doc.image)
                          }
                          // style={{ textDecoration: "none" }}
                        >
                          <i className="fa-solid fa-photo-film"></i> :{" "}
                          {doc.type === "official_extract_commercial_register"
                            ? "مستخرج رسمي من السجل التجاري"
                            : doc.type ===
                              "certificate_registration_relevant_chamber"
                            ? "صورة شهادة قيد بالغرفة المختصة"
                            : doc.type === "tax_card"
                            ? "صورة من البطاقة الضريبية"
                            : doc.type ===
                              "document_exploitation_location_place"
                            ? "سند استغلال موقع الأعلان"
                            : doc.type === "title_deed"
                            ? "سند ملكية الأرض"
                            : doc.type === "cost_calculation_form"
                            ? "نموزج حساب التكاليف"
                            : doc.type === "insurance_policy"
                            ? "وثيقة تأمين "
                            : doc.type === "business_validity_certificate"
                            ? "شهادة صلاحية الأعمال للتراخيص موقعة من المهندس"
                            : doc.type ===
                              "insurance_document_construction_drawings"
                            ? "وثيقة تأمين بها نسبة من الرسومات الأنشائية معتمدة من المحطة العشرية"
                            : doc.type === "detect_recorders"
                            ? "كشف مسجلات لأكثر من عامين"
                            : doc.type === "property_picture"
                            ? "صورة للعقار"
                            : doc.type === "tax_certificate"
                            ? "شهادة من مأمورية الضرائب"
                            : doc.type ===
                              "final_decision_administrative_authority_demolish"
                            ? "قرار نهائي من الجهة الأدارية بالهدم"
                            : doc.type === "elevator_installation_contract"
                            ? "عقد تركيب المصعد من احد الشركات مع صورة من تصريح مزاولة المهنة "
                            : doc.type ===
                              "elevator_company_registration_classification_card"
                            ? "صورة من بطاقة قيد وتصنيف شركة المصاعد بالأتحاد المصري لمقاولي التنفيذ والبناء"
                            : doc.type ===
                              "technical_engineering_specifications_file"
                            ? "ملف الموصفات الفنية والرسومات الهندسية"
                            : doc.type === "assessment_includes_business"
                            ? "مقاييس تتضمن الأعمال"
                            : doc.type === "arithmetic_note"
                            ? "نوتة حسابية من مكتب المهندس"
                            : doc.type === "structural_engineer_report"
                            ? "تقرير مهندس انشائي "
                            : doc.type === "license_application"
                            ? "طلب الترخيص"
                            : doc.type === "lease"
                            ? "صورة من مستند الايجار ساري لمدة مناسبة وموضح النشاط"
                            : doc.type === "ownership_contract"
                            ? "صورة من مستند الملكية ساري لمدة مناسبة وموضح النشاط"
                            : doc.type === "construction_license"
                            ? "صورة من رخصة البناء"
                            : doc.type === "organization_benefit_store_position"
                            ? "افادة من التنظيم بموقف المحل (رخصة - تقنين)"
                            : doc.type ===
                              "real_estate_transactions_certificate"
                            ? "شهادة تصرف عقاري"
                            : doc.type === "certified_engineering_report"
                            ? "تقرير هندسي معتمد يثبت السلامة الأنشائية"
                            : doc.type === "sketch_showing_location"
                            ? "الرسم الكروكي"
                            : doc.type === "power_attoreny"
                            ? "التوكيل"
                            : doc.type === "original_license"
                            ? "اصل الرخصة"
                            : doc.type === "payment_receipt"
                            ? "إيصال الدفع"
                            : doc.type === "criminal_record"
                            ? "صحيفة الحالة الجنائية"
                            : doc.type === "assignment_contract"
                            ? "عقد التنازل ومصدق من الشهر العقاري"
                            : doc.type === "benefits_assignee_insurance"
                            ? "ما يفيد المتنازل الية بالتأمينات"
                            : doc.type === "military_service"
                            ? "الموقف من التجنيد"
                            : doc.type ===
                              "construction_drawings_advertising_stands"
                            ? "نسختان من الرسومات الأنشائية للحوامل بالأعلان"
                            : doc.type ===
                              "drawings_electrical_installations_connections"
                            ? "نسختان من الرسومات للتركيبات و للتوصيلات الكهربائية "
                            : doc.type === "passport"
                            ? "جواز السفر"
                            : doc.type === "engineering_drawings"
                            ? "الرسومات الهندسية"
                            : doc.type === "client_national_id"
                            ? "البطاقة الشخصية"
                            : doc.type === "health_certificate_employees"
                            ? "شهادة صحية لجميع العاملين"
                            : doc.type ===
                              "assigned_national_identification_number"
                            ? "صورة بطاقة الرقم القومي للمتنازل والمتنازل الية"
                            : doc.type === "notification_of_violation_report"
                            ? "اخطار بمحضر المخالفة او صورة منها"
                            : doc.type === "value_of_paying_the_violation"
                            ? "قيمة سداد المخالفة او صورة لها"
                            : doc.type ===
                              "document_proving_ownership_of_seized_items"
                            ? "مستند يفيد ملكية هذه المضبوطات"
                            : doc.type === "copy_of_report_detailing_seizures"
                            ? "صورة المحضر ببيان المضبوطات المتحفظ عليها"
                            : doc.type === "license_waiver_contract"
                            ? "عقد تنازل عن الترخيص بالاشغالات من المتنازل الي المتنازل الية"
                            : doc.type === "receipt_proving_payment_of_fees"
                            ? "الإيصال الدال على سداد رسم"
                            : doc.type ===
                              "engineering_or_sketch_drawing_of_works_site"
                            ? "رسم هندسي او كروكي لموقع الاشغال"
                            : doc.type === "license"
                            ? "الرخصة"
                            : doc.type === "other"
                            ? "ملفات اخرى"
                            : ""}
                        </button>
                      </p>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ) : appdata &&
            appdata.local_services &&
            appdata.local_services.type === 4 ? (
            <div className="row">
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">رقم الطلب</p>
                    <p className="card-text fw-bold">
                      {appdata.application.application_id}#
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">نوع الطلب</p>
                    <p className="card-text fw-bold">خدمات الأعلانات</p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">نوع الخدمة</p>
                    <p className="card-text fw-bold">
                      {appdata.local_services.category === 16
                        ? "طلب الحصول على ترخيص او تجديد بروز اعلان عربية"
                        : ""}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">تفاصيل</p>
                    <p className="card-text fw-bold">
                      {appdata.local_services.details}
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">صورة الإيصال</p>
                    <p className="card-text fw-bold">
                      <TextField
                        label="صورة الإيصال"
                        focused
                        // inputProps={{ multiple: true }}
                        type="file"
                        onChange={(e) => seresal(e.target.files[0])}
                        variant="outlined"
                      />
                      {isPress && loading ? (
                        <button className="buttonadd">
                          <Spinner />
                        </button>
                      ) : (
                        <button className="buttonadd" onClick={handlesubmit}>
                          {" "}
                          إرسال
                        </button>
                      )}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">ملاحظات</p>
                    {Comeents && Comeents.length > 0
                      ? Comeents.map((item, idx) => (
                          <div key={idx}>
                            <p className="card-text fw-bold">
                              بواسطة : {item.username}
                            </p>
                            <p className="card-text fw-bold">{item.comment}</p>

                            <p className="card-text fw-bold">
                              منذ :{" "}
                              {new Date(item.creation_date).toLocaleString(
                                "en-US"
                              )}
                            </p>
                          </div>
                        ))
                      : null}
                  </div>
                </div>
              </div>
              <div
                style={{ color: "red", cursor: "pointer" }}
                onClick={() =>
                  handleShowDelete(appdata.application.application_id)
                }
              >
                هل تريد حذف الطلب <i className="fa-solid fa-trash-can"></i>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">الملفات</p>
                    {appdata.documents.map((doc, idx) => (
                      <p className="card-text fw-bold" key={idx}>
                        <button
                          className="buttonadd "
                          style={{ margin: "5px 0px 5px 0px" }}
                          onClick={() =>
                            handleShowpopup(baseUrlImg + doc.image)
                          }
                          // style={{ textDecoration: "none" }}
                        >
                          <i className="fa-solid fa-photo-film"></i> :{" "}
                          {doc.type === "official_extract_commercial_register"
                            ? "مستخرج رسمي من السجل التجاري"
                            : doc.type ===
                              "certificate_registration_relevant_chamber"
                            ? "صورة شهادة قيد بالغرفة المختصة"
                            : doc.type === "tax_card"
                            ? "صورة من البطاقة الضريبية"
                            : doc.type ===
                              "document_exploitation_location_place"
                            ? "سند استغلال موقع الأعلان"
                            : doc.type === "title_deed"
                            ? "سند ملكية الأرض"
                            : doc.type === "cost_calculation_form"
                            ? "نموزج حساب التكاليف"
                            : doc.type === "insurance_policy"
                            ? "وثيقة تأمين "
                            : doc.type === "business_validity_certificate"
                            ? "شهادة صلاحية الأعمال للتراخيص موقعة من المهندس"
                            : doc.type ===
                              "insurance_document_construction_drawings"
                            ? "وثيقة تأمين بها نسبة من الرسومات الأنشائية معتمدة من المحطة العشرية"
                            : doc.type === "detect_recorders"
                            ? "كشف مسجلات لأكثر من عامين"
                            : doc.type === "property_picture"
                            ? "صورة للعقار"
                            : doc.type === "tax_certificate"
                            ? "شهادة من مأمورية الضرائب"
                            : doc.type ===
                              "final_decision_administrative_authority_demolish"
                            ? "قرار نهائي من الجهة الأدارية بالهدم"
                            : doc.type === "elevator_installation_contract"
                            ? "عقد تركيب المصعد من احد الشركات مع صورة من تصريح مزاولة المهنة "
                            : doc.type ===
                              "elevator_company_registration_classification_card"
                            ? "صورة من بطاقة قيد وتصنيف شركة المصاعد بالأتحاد المصري لمقاولي التنفيذ والبناء"
                            : doc.type ===
                              "technical_engineering_specifications_file"
                            ? "ملف الموصفات الفنية والرسومات الهندسية"
                            : doc.type === "assessment_includes_business"
                            ? "مقاييس تتضمن الأعمال"
                            : doc.type === "arithmetic_note"
                            ? "نوتة حسابية من مكتب المهندس"
                            : doc.type === "structural_engineer_report"
                            ? "تقرير مهندس انشائي "
                            : doc.type === "license_application"
                            ? "طلب الترخيص"
                            : doc.type === "lease"
                            ? "صورة من مستند الايجار ساري لمدة مناسبة وموضح النشاط"
                            : doc.type === "ownership_contract"
                            ? "صورة من مستند الملكية ساري لمدة مناسبة وموضح النشاط"
                            : doc.type === "construction_license"
                            ? "صورة من رخصة البناء"
                            : doc.type === "organization_benefit_store_position"
                            ? "افادة من التنظيم بموقف المحل (رخصة - تقنين)"
                            : doc.type ===
                              "real_estate_transactions_certificate"
                            ? "شهادة تصرف عقاري"
                            : doc.type === "certified_engineering_report"
                            ? "تقرير هندسي معتمد يثبت السلامة الأنشائية"
                            : doc.type === "sketch_showing_location"
                            ? "الرسم الكروكي"
                            : doc.type === "power_attoreny"
                            ? "التوكيل"
                            : doc.type === "original_license"
                            ? "اصل الرخصة"
                            : doc.type === "payment_receipt"
                            ? "إيصال الدفع"
                            : doc.type === "criminal_record"
                            ? "صحيفة الحالة الجنائية"
                            : doc.type === "assignment_contract"
                            ? "عقد التنازل ومصدق من الشهر العقاري"
                            : doc.type === "benefits_assignee_insurance"
                            ? "ما يفيد المتنازل الية بالتأمينات"
                            : doc.type === "military_service"
                            ? "الموقف من التجنيد"
                            : doc.type ===
                              "construction_drawings_advertising_stands"
                            ? "نسختان من الرسومات الأنشائية للحوامل بالأعلان"
                            : doc.type ===
                              "drawings_electrical_installations_connections"
                            ? "نسختان من الرسومات للتركيبات و للتوصيلات الكهربائية "
                            : doc.type === "passport"
                            ? "جواز السفر"
                            : doc.type === "engineering_drawings"
                            ? "الرسومات الهندسية"
                            : doc.type === "client_national_id"
                            ? "البطاقة الشخصية"
                            : doc.type === "health_certificate_employees"
                            ? "شهادة صحية لجميع العاملين"
                            : doc.type === "other"
                            ? "ملفات اخرى"
                            : ""}
                        </button>
                      </p>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ) : appdata &&
            appdata.local_services &&
            appdata.local_services.type === 5 ? (
            <div className="row">
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">رقم الطلب</p>
                    <p className="card-text fw-bold">
                      {appdata.application.application_id}#
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">نوع الطلب</p>
                    <p className="card-text fw-bold">خدمات المصاعد</p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">نوع الخدمة</p>
                    <p className="card-text fw-bold">
                      {appdata.local_services.category === 14
                        ? "طلب الحصول على تركيب مصعد"
                        : appdata.local_services.category === 15
                        ? "طلب الحصول على رخصة تشغيل مصعد"
                        : ""}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">تفاصيل</p>
                    <p className="card-text fw-bold">
                      {appdata.local_services.details}
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">صورة الإيصال</p>
                    <p className="card-text fw-bold">
                      <TextField
                        label="صورة الإيصال"
                        focused
                        // inputProps={{ multiple: true }}
                        type="file"
                        onChange={(e) => seresal(e.target.files[0])}
                        variant="outlined"
                      />
                      {isPress && loading ? (
                        <button className="buttonadd">
                          <Spinner />
                        </button>
                      ) : (
                        <button className="buttonadd" onClick={handlesubmit}>
                          {" "}
                          إرسال
                        </button>
                      )}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">ملاحظات</p>
                    {Comeents && Comeents.length > 0
                      ? Comeents.map((item, idx) => (
                          <div key={idx}>
                            <p className="card-text fw-bold">
                              بواسطة : {item.username}
                            </p>
                            <p className="card-text fw-bold">{item.comment}</p>

                            <p className="card-text fw-bold">
                              منذ :{" "}
                              {new Date(item.creation_date).toLocaleString(
                                "en-US"
                              )}
                            </p>
                          </div>
                        ))
                      : null}
                  </div>
                </div>
              </div>
              <div
                style={{ color: "red", cursor: "pointer" }}
                onClick={() =>
                  handleShowDelete(appdata.application.application_id)
                }
              >
                هل تريد حذف الطلب <i className="fa-solid fa-trash-can"></i>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">الملفات</p>
                    {appdata.documents.map((doc, idx) => (
                      <p className="card-text fw-bold" key={idx}>
                        <button
                          className="buttonadd "
                          style={{ margin: "5px 0px 5px 0px" }}
                          onClick={() =>
                            handleShowpopup(baseUrlImg + doc.image)
                          }
                          // style={{ textDecoration: "none" }}
                        >
                          <i className="fa-solid fa-photo-film"></i> :{" "}
                          {doc.type === "official_extract_commercial_register"
                            ? "مستخرج رسمي من السجل التجاري"
                            : doc.type ===
                              "certificate_registration_relevant_chamber"
                            ? "صورة شهادة قيد بالغرفة المختصة"
                            : doc.type === "tax_card"
                            ? "صورة من البطاقة الضريبية"
                            : doc.type ===
                              "document_exploitation_location_place"
                            ? "سند استغلال موقع الأعلان"
                            : doc.type === "title_deed"
                            ? "سند ملكية الأرض"
                            : doc.type === "cost_calculation_form"
                            ? "نموزج حساب التكاليف"
                            : doc.type === "insurance_policy"
                            ? "وثيقة تأمين "
                            : doc.type === "business_validity_certificate"
                            ? "شهادة صلاحية الأعمال للتراخيص موقعة من المهندس"
                            : doc.type ===
                              "insurance_document_construction_drawings"
                            ? "وثيقة تأمين بها نسبة من الرسومات الأنشائية معتمدة من المحطة العشرية"
                            : doc.type === "detect_recorders"
                            ? "كشف مسجلات لأكثر من عامين"
                            : doc.type === "property_picture"
                            ? "صورة للعقار"
                            : doc.type === "tax_certificate"
                            ? "شهادة من مأمورية الضرائب"
                            : doc.type ===
                              "final_decision_administrative_authority_demolish"
                            ? "قرار نهائي من الجهة الأدارية بالهدم"
                            : doc.type === "elevator_installation_contract"
                            ? "عقد تركيب المصعد من احد الشركات مع صورة من تصريح مزاولة المهنة "
                            : doc.type ===
                              "elevator_company_registration_classification_card"
                            ? "صورة من بطاقة قيد وتصنيف شركة المصاعد بالأتحاد المصري لمقاولي التنفيذ والبناء"
                            : doc.type ===
                              "technical_engineering_specifications_file"
                            ? "ملف الموصفات الفنية والرسومات الهندسية"
                            : doc.type === "assessment_includes_business"
                            ? "مقاييس تتضمن الأعمال"
                            : doc.type === "arithmetic_note"
                            ? "نوتة حسابية من مكتب المهندس"
                            : doc.type === "structural_engineer_report"
                            ? "تقرير مهندس انشائي "
                            : doc.type === "license_application"
                            ? "طلب الترخيص"
                            : doc.type === "lease"
                            ? "صورة من مستند الايجار ساري لمدة مناسبة وموضح النشاط"
                            : doc.type === "ownership_contract"
                            ? "صورة من مستند الملكية ساري لمدة مناسبة وموضح النشاط"
                            : doc.type === "construction_license"
                            ? "صورة من رخصة البناء"
                            : doc.type === "organization_benefit_store_position"
                            ? "افادة من التنظيم بموقف المحل (رخصة - تقنين)"
                            : doc.type ===
                              "real_estate_transactions_certificate"
                            ? "شهادة تصرف عقاري"
                            : doc.type === "certified_engineering_report"
                            ? "تقرير هندسي معتمد يثبت السلامة الأنشائية"
                            : doc.type === "sketch_showing_location"
                            ? "الرسم الكروكي"
                            : doc.type === "power_attoreny"
                            ? "التوكيل"
                            : doc.type === "original_license"
                            ? "اصل الرخصة"
                            : doc.type === "payment_receipt"
                            ? "إيصال الدفع"
                            : doc.type === "criminal_record"
                            ? "صحيفة الحالة الجنائية"
                            : doc.type === "assignment_contract"
                            ? "عقد التنازل ومصدق من الشهر العقاري"
                            : doc.type === "benefits_assignee_insurance"
                            ? "ما يفيد المتنازل الية بالتأمينات"
                            : doc.type === "military_service"
                            ? "الموقف من التجنيد"
                            : doc.type ===
                              "construction_drawings_advertising_stands"
                            ? "نسختان من الرسومات الأنشائية للحوامل بالأعلان"
                            : doc.type ===
                              "drawings_electrical_installations_connections"
                            ? "نسختان من الرسومات للتركيبات و للتوصيلات الكهربائية "
                            : doc.type === "passport"
                            ? "جواز السفر"
                            : doc.type === "engineering_drawings"
                            ? "الرسومات الهندسية"
                            : doc.type === "client_national_id"
                            ? "البطاقة الشخصية"
                            : doc.type === "health_certificate_employees"
                            ? "شهادة صحية لجميع العاملين"
                            : doc.type === "other"
                            ? "ملفات اخرى"
                            : ""}
                        </button>
                      </p>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ) : appdata &&
            appdata.local_services &&
            appdata.local_services.type === 6 ? (
            <div className="row">
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">رقم الطلب</p>
                    <p className="card-text fw-bold">
                      {appdata.application.application_id}#
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">نوع الطلب</p>
                    <p className="card-text fw-bold">خدمات المحلات التجارية</p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">نوع الخدمة</p>
                    <p className="card-text fw-bold">
                      {appdata.local_services.category === 17
                        ? "فتح محل"
                        : appdata.local_services.category === 18
                        ? "تشغيل محل صناعي أو تجاري"
                        : appdata.local_services.category === 19
                        ? "تجديد ترخيص محل"
                        : appdata.local_services.category === 20
                        ? "تعديل ترخيص محل صناعي او تجاري"
                        : appdata.local_services.category === 21
                        ? "تعديل ترخيص محل عام"
                        : appdata.local_services.category === 22
                        ? "تعديل ترخيص بأضافة شريك او اخراج شريك"
                        : appdata.local_services.category === 23
                        ? "طلب نقل رخصة"
                        : appdata.local_services.category === 24
                        ? "طلب الغاء رخصة"
                        : ""}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">تفاصيل</p>
                    <p className="card-text fw-bold">
                      {appdata.local_services.details}
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">صورة الإيصال</p>
                    <p className="card-text fw-bold">
                      <TextField
                        label="صورة الإيصال"
                        focused
                        // inputProps={{ multiple: true }}
                        type="file"
                        onChange={(e) => seresal(e.target.files[0])}
                        variant="outlined"
                      />
                      {isPress && loading ? (
                        <button className="buttonadd">
                          <Spinner />
                        </button>
                      ) : (
                        <button className="buttonadd" onClick={handlesubmit}>
                          {" "}
                          إرسال
                        </button>
                      )}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">ملاحظات</p>
                    {Comeents && Comeents.length > 0
                      ? Comeents.map((item, idx) => (
                          <div key={idx}>
                            <p className="card-text fw-bold">
                              بواسطة : {item.username}
                            </p>
                            <p className="card-text fw-bold">{item.comment}</p>

                            <p className="card-text fw-bold">
                              منذ :{" "}
                              {new Date(item.creation_date).toLocaleString(
                                "en-US"
                              )}
                            </p>
                          </div>
                        ))
                      : null}
                  </div>
                </div>
              </div>
              <div
                style={{ color: "red", cursor: "pointer" }}
                onClick={() =>
                  handleShowDelete(appdata.application.application_id)
                }
              >
                هل تريد حذف الطلب <i className="fa-solid fa-trash-can"></i>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">الملفات</p>
                    {appdata.documents.map((doc, idx) => (
                      <p className="card-text fw-bold" key={idx}>
                        <button
                          className="buttonadd "
                          style={{ margin: "5px 0px 5px 0px" }}
                          onClick={() =>
                            handleShowpopup(baseUrlImg + doc.image)
                          }
                          // style={{ textDecoration: "none" }}
                        >
                          <i className="fa-solid fa-photo-film"></i> :{" "}
                          {doc.type === "official_extract_commercial_register"
                            ? "مستخرج رسمي من السجل التجاري"
                            : doc.type ===
                              "certificate_registration_relevant_chamber"
                            ? "صورة شهادة قيد بالغرفة المختصة"
                            : doc.type === "tax_card"
                            ? "صورة من البطاقة الضريبية"
                            : doc.type ===
                              "document_exploitation_location_place"
                            ? "سند استغلال موقع الأعلان"
                            : doc.type === "title_deed"
                            ? "سند ملكية الأرض"
                            : doc.type === "cost_calculation_form"
                            ? "نموزج حساب التكاليف"
                            : doc.type === "insurance_policy"
                            ? "وثيقة تأمين "
                            : doc.type === "business_validity_certificate"
                            ? "شهادة صلاحية الأعمال للتراخيص موقعة من المهندس"
                            : doc.type ===
                              "insurance_document_construction_drawings"
                            ? "وثيقة تأمين بها نسبة من الرسومات الأنشائية معتمدة من المحطة العشرية"
                            : doc.type === "detect_recorders"
                            ? "كشف مسجلات لأكثر من عامين"
                            : doc.type === "property_picture"
                            ? "صورة للعقار"
                            : doc.type === "tax_certificate"
                            ? "شهادة من مأمورية الضرائب"
                            : doc.type ===
                              "final_decision_administrative_authority_demolish"
                            ? "قرار نهائي من الجهة الأدارية بالهدم"
                            : doc.type === "elevator_installation_contract"
                            ? "عقد تركيب المصعد من احد الشركات مع صورة من تصريح مزاولة المهنة "
                            : doc.type ===
                              "elevator_company_registration_classification_card"
                            ? "صورة من بطاقة قيد وتصنيف شركة المصاعد بالأتحاد المصري لمقاولي التنفيذ والبناء"
                            : doc.type ===
                              "technical_engineering_specifications_file"
                            ? "ملف الموصفات الفنية والرسومات الهندسية"
                            : doc.type === "assessment_includes_business"
                            ? "مقاييس تتضمن الأعمال"
                            : doc.type === "arithmetic_note"
                            ? "نوتة حسابية من مكتب المهندس"
                            : doc.type === "structural_engineer_report"
                            ? "تقرير مهندس انشائي "
                            : doc.type === "license_application"
                            ? "طلب الترخيص"
                            : doc.type === "lease"
                            ? "صورة من مستند الايجار ساري لمدة مناسبة وموضح النشاط"
                            : doc.type === "ownership_contract"
                            ? "صورة من مستند الملكية ساري لمدة مناسبة وموضح النشاط"
                            : doc.type === "construction_license"
                            ? "صورة من رخصة البناء"
                            : doc.type === "organization_benefit_store_position"
                            ? "افادة من التنظيم بموقف المحل (رخصة - تقنين)"
                            : doc.type ===
                              "real_estate_transactions_certificate"
                            ? "شهادة تصرف عقاري"
                            : doc.type === "certified_engineering_report"
                            ? "تقرير هندسي معتمد يثبت السلامة الأنشائية"
                            : doc.type === "sketch_showing_location"
                            ? "الرسم الكروكي"
                            : doc.type === "power_attoreny"
                            ? "التوكيل"
                            : doc.type === "original_license"
                            ? "اصل الرخصة"
                            : doc.type === "criminal_record"
                            ? "صحيفة الحالة الجنائية"
                            : doc.type === "assignment_contract"
                            ? "عقد التنازل ومصدق من الشهر العقاري"
                            : doc.type === "benefits_assignee_insurance"
                            ? "ما يفيد المتنازل الية بالتأمينات"
                            : doc.type === "military_service"
                            ? "الموقف من التجنيد"
                            : doc.type ===
                              "construction_drawings_advertising_stands"
                            ? "نسختان من الرسومات الأنشائية للحوامل بالأعلان"
                            : doc.type ===
                              "drawings_electrical_installations_connections"
                            ? "نسختان من الرسومات للتركيبات و للتوصيلات الكهربائية "
                            : doc.type === "passport"
                            ? "جواز السفر"
                            : doc.type === "engineering_drawings"
                            ? "الرسومات الهندسية"
                            : doc.type === "client_national_id"
                            ? "البطاقة الشخصية"
                            : doc.type === "health_certificate_employees"
                            ? "شهادة صحية لجميع العاملين"
                            : doc.type === "other"
                            ? "ملفات اخرى"
                            : ""}
                        </button>
                      </p>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ) : appdata &&
            appdata.local_services &&
            appdata.local_services.type === 7 ? (
            <div className="row">
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">رقم الطلب</p>
                    <p className="card-text fw-bold">
                      {appdata.application.application_id}#
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">نوع الطلب</p>
                    <p className="card-text fw-bold">خدمات اخرى </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">نوع الخدمة</p>
                    <p className="card-text fw-bold">
                      {appdata.local_services.category === 25
                        ? "طلب توصيل عداد مرافق"
                        : appdata.local_services.category === 26
                        ? "طلب توصيل مرافق دائم"
                        : appdata.local_services.category === 27
                        ? "طلب الترخيص بتوصيل مرافق للمنازل القديمة"
                        : appdata.local_services.category === 28
                        ? "طلب بالحفر لتوصيل المرافق"
                        : appdata.local_services.category === 29
                        ? "طلب ترخيص او اقامة مدفن"
                        : ""}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">تفاصيل</p>
                    <p className="card-text fw-bold">
                      {appdata.local_services.details}
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">صورة الإيصال</p>
                    <p className="card-text fw-bold">
                      <TextField
                        label="صورة الإيصال"
                        focused
                        // inputProps={{ multiple: true }}
                        type="file"
                        onChange={(e) => seresal(e.target.files[0])}
                        variant="outlined"
                      />
                      {isPress && loading ? (
                        <button className="buttonadd">
                          <Spinner />
                        </button>
                      ) : (
                        <button className="buttonadd" onClick={handlesubmit}>
                          {" "}
                          إرسال
                        </button>
                      )}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">ملاحظات</p>
                    {Comeents && Comeents.length > 0
                      ? Comeents.map((item, idx) => (
                          <div key={idx}>
                            <p className="card-text fw-bold">
                              بواسطة : {item.username}
                            </p>
                            <p className="card-text fw-bold">{item.comment}</p>

                            <p className="card-text fw-bold">
                              منذ :{" "}
                              {new Date(item.creation_date).toLocaleString(
                                "en-US"
                              )}
                            </p>
                          </div>
                        ))
                      : null}
                  </div>
                </div>
              </div>
              <div
                style={{ color: "red", cursor: "pointer" }}
                onClick={() =>
                  handleShowDelete(appdata.application.application_id)
                }
              >
                هل تريد حذف الطلب <i className="fa-solid fa-trash-can"></i>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">الملفات</p>
                    {appdata.documents.map((doc, idx) => (
                      <p className="card-text fw-bold" key={idx}>
                        <button
                          className="buttonadd "
                          style={{ margin: "5px 0px 5px 0px" }}
                          onClick={() =>
                            handleShowpopup(baseUrlImg + doc.image)
                          }
                          // style={{ textDecoration: "none" }}
                        >
                          <i className="fa-solid fa-photo-film"></i> :{" "}
                          {doc.type === "official_extract_commercial_register"
                            ? "مستخرج رسمي من السجل التجاري"
                            : doc.type ===
                              "certificate_registration_relevant_chamber"
                            ? "صورة شهادة قيد بالغرفة المختصة"
                            : doc.type === "tax_card"
                            ? "صورة من البطاقة الضريبية"
                            : doc.type ===
                              "document_exploitation_location_place"
                            ? "سند استغلال موقع الأعلان"
                            : doc.type === "title_deed"
                            ? "سند ملكية الأرض"
                            : doc.type === "cost_calculation_form"
                            ? "نموزج حساب التكاليف"
                            : doc.type === "insurance_policy"
                            ? "وثيقة تأمين "
                            : doc.type === "business_validity_certificate"
                            ? "شهادة صلاحية الأعمال للتراخيص موقعة من المهندس"
                            : doc.type ===
                              "insurance_document_construction_drawings"
                            ? "وثيقة تأمين بها نسبة من الرسومات الأنشائية معتمدة من المحطة العشرية"
                            : doc.type === "detect_recorders"
                            ? "كشف مسجلات لأكثر من عامين"
                            : doc.type === "property_picture"
                            ? "صورة للعقار"
                            : doc.type === "tax_certificate"
                            ? "شهادة من مأمورية الضرائب"
                            : doc.type ===
                              "final_decision_administrative_authority_demolish"
                            ? "قرار نهائي من الجهة الأدارية بالهدم"
                            : doc.type === "elevator_installation_contract"
                            ? "عقد تركيب المصعد من احد الشركات مع صورة من تصريح مزاولة المهنة "
                            : doc.type ===
                              "elevator_company_registration_classification_card"
                            ? "صورة من بطاقة قيد وتصنيف شركة المصاعد بالأتحاد المصري لمقاولي التنفيذ والبناء"
                            : doc.type ===
                              "technical_engineering_specifications_file"
                            ? "ملف الموصفات الفنية والرسومات الهندسية"
                            : doc.type === "assessment_includes_business"
                            ? "مقاييس تتضمن الأعمال"
                            : doc.type === "arithmetic_note"
                            ? "نوتة حسابية من مكتب المهندس"
                            : doc.type === "structural_engineer_report"
                            ? "تقرير مهندس انشائي "
                            : doc.type === "license_application"
                            ? "طلب الترخيص"
                            : doc.type === "lease"
                            ? "صورة من مستند الايجار ساري لمدة مناسبة وموضح النشاط"
                            : doc.type === "ownership_contract"
                            ? "صورة من مستند الملكية ساري لمدة مناسبة وموضح النشاط"
                            : doc.type === "construction_license"
                            ? "صورة من رخصة البناء"
                            : doc.type === "organization_benefit_store_position"
                            ? "افادة من التنظيم بموقف المحل (رخصة - تقنين)"
                            : doc.type ===
                              "real_estate_transactions_certificate"
                            ? "شهادة تصرف عقاري"
                            : doc.type === "certified_engineering_report"
                            ? "تقرير هندسي معتمد يثبت السلامة الأنشائية"
                            : doc.type === "sketch_showing_location"
                            ? "الرسم الكروكي"
                            : doc.type === "power_attoreny"
                            ? "التوكيل"
                            : doc.type === "original_license"
                            ? "اصل الرخصة"
                            : doc.type === "criminal_record"
                            ? "صحيفة الحالة الجنائية"
                            : doc.type === "assignment_contract"
                            ? "عقد التنازل ومصدق من الشهر العقاري"
                            : doc.type === "benefits_assignee_insurance"
                            ? "ما يفيد المتنازل الية بالتأمينات"
                            : doc.type === "military_service"
                            ? "الموقف من التجنيد"
                            : doc.type ===
                              "construction_drawings_advertising_stands"
                            ? "نسختان من الرسومات الأنشائية للحوامل بالأعلان"
                            : doc.type ===
                              "drawings_electrical_installations_connections"
                            ? "نسختان من الرسومات للتركيبات و للتوصيلات الكهربائية "
                            : doc.type === "passport"
                            ? "جواز السفر"
                            : doc.type === "engineering_drawings"
                            ? "الرسومات الهندسية"
                            : doc.type === "client_national_id"
                            ? "البطاقة الشخصية"
                            : doc.type === "health_certificate_employees"
                            ? "شهادة صحية لجميع العاملين"
                            : doc.type === "other"
                            ? "ملفات اخرى"
                            : ""}
                        </button>
                      </p>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ) : appdata && appdata.transaction ? (
            <div className="row">
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">رقم الطلب</p>
                    <p className="card-text fw-bold">
                      {appdata.application.application_id}#
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">نوع الطلب</p>
                    <p className="card-text fw-bold">خدمات تخليص المعاملات</p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">نوع الخدمة</p>
                    <p className="card-text fw-bold">
                      {appdata.transaction.company === "gas"
                        ? "خدمات الغاز"
                        : appdata.transaction.company === "electricity"
                        ? "خدمات الكهرباء"
                        : ""}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">وصف الخدمة</p>
                    <p className="card-text fw-bold">
                      {appdata.transaction.type === 1
                        ? "خدمات تركيب العداد"
                        : appdata.transaction.type === 2
                        ? "توصيل التيار الكهربي "
                        : appdata.transaction.type === 3
                        ? "طلبات استخراج "
                        : appdata.transaction.type === 4
                        ? "تصحيح البيانات "
                        : appdata.transaction.type === 5
                        ? "استبدال عداد بقدره اكبر "
                        : appdata.transaction.type === 6
                        ? "تنازل عن العداد "
                        : appdata.transaction.type === 7
                        ? "تسجيل قراءه العداد "
                        : appdata.transaction.type === 8
                        ? "جدوله مديونيه متاخره"
                        : appdata.transaction.type === 9
                        ? "خدمه توصيل الغاز للافراد "
                        : appdata.transaction.type === 10
                        ? "خدمه توصيل الغاز للشركات "
                        : appdata.transaction.type === 11
                        ? "خدمه التوسيعات"
                        : null}
                    </p>
                  </div>
                </div>
              </div>
              {appdata.transaction.category !== "" ? (
                <div className="col-sm-6 mb-3 mb-sm-2">
                  <div className="card bg-light">
                    <div className="card-body">
                      <p className="card-title opacity-75"></p>
                      <p className="card-text fw-bold">
                        {" "}
                        {appdata.transaction.category === 1
                          ? "تركيب عداد لأول مرة"
                          : appdata.transaction.category === 2
                          ? "تركيب عداد ممارسة"
                          : appdata.transaction.category === 3
                          ? "تركيب عداد بدل فاقد"
                          : appdata.transaction.category === 4
                          ? "عداد انشائي"
                          : appdata.transaction.category === 5
                          ? "عداد للمباني السكنية"
                          : appdata.transaction.category === 6
                          ? "عداد للمشروعات الصغيرة او المتوسطة"
                          : appdata.transaction.category === 7
                          ? "شهادة بيان تعاقد"
                          : appdata.transaction.category === 8
                          ? "شهادة استهلاك"
                          : appdata.transaction.category === 9
                          ? "كارت بدل فاقد"
                          : appdata.transaction.category === 10
                          ? "صاحب العداد"
                          : appdata.transaction.category === 11
                          ? "قراءة العداد"
                          : ""}{" "}
                      </p>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}
                   {appdata.transaction.building_entrance_number !== "" ? (
                <div className="col-sm-6 mb-3 mb-sm-2">
                  <div className="card bg-light">
                    <div className="card-body">
                      <p className="card-title opacity-75">رقم مدخل العمارة</p>
                      <p className="card-text fw-bold">
                        {appdata.transaction.building_entrance_number}
                      </p>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}
              {appdata.transaction.apartment_number !== "" ? (
                <div className="col-sm-6 mb-3 mb-sm-2">
                  <div className="card bg-light">
                    <div className="card-body">
                      <p className="card-title opacity-75">رقم الشقة</p>
                      <p className="card-text fw-bold">
                        {appdata.transaction.apartment_number}
                      </p>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">تفاصيل</p>
                    <p className="card-text fw-bold">
                      {appdata.transaction.details}
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">صورة الإيصال</p>
                    <p className="card-text fw-bold">
                      <TextField
                        label="صورة الإيصال"
                        focused
                        // inputProps={{ multiple: true }}
                        type="file"
                        onChange={(e) => seresal(e.target.files[0])}
                        variant="outlined"
                      />
                      {isPress && loading ? (
                        <button className="buttonadd">
                          <Spinner />
                        </button>
                      ) : (
                        <button className="buttonadd" onClick={handlesubmit}>
                          {" "}
                          إرسال
                        </button>
                      )}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">ملاحظات</p>
                    {Comeents && Comeents.length > 0
                      ? Comeents.map((item, idx) => (
                          <div key={idx}>
                            <p className="card-text fw-bold">
                              بواسطة : {item.username}
                            </p>
                            <p className="card-text fw-bold">{item.comment}</p>

                            <p className="card-text fw-bold">
                              منذ :{" "}
                              {new Date(item.creation_date).toLocaleString(
                                "en-US"
                              )}
                            </p>
                          </div>
                        ))
                      : null}
                  </div>
                </div>
              </div>
              <div
                style={{ color: "red", cursor: "pointer" }}
                onClick={() =>
                  handleShowDelete(appdata.application.application_id)
                }
              >
                هل تريد حذف الطلب <i className="fa-solid fa-trash-can"></i>
              </div>
              <div className="col-sm-6 mb-3 mb-sm-2">
                <div className="card bg-light">
                  <div className="card-body">
                    <p className="card-title opacity-75">الملفات</p>
                    {appdata.documents.map((doc, idx) => (
                      <p className="card-text fw-bold" key={idx}>
                        <button
                          className="buttonadd "
                          style={{ margin: "5px 0px 5px 0px" }}
                          onClick={() =>
                            handleShowpopup(baseUrlImg + doc.image)
                          }
                          // style={{ textDecoration: "none" }}
                        >
                          <i className="fa-solid fa-photo-film"></i> :{" "}
                          {doc.type === "official_extract_commercial_register"
                            ? "مستخرج رسمي من السجل التجاري"
                            : doc.type ===
                              "certificate_registration_relevant_chamber"
                            ? "صورة شهادة قيد بالغرفة المختصة"
                            : doc.type === "tax_card"
                            ? "صورة من البطاقة الضريبية"
                            : doc.type ===
                              "document_exploitation_location_place"
                            ? "سند استغلال موقع الأعلان"
                            : doc.type === "title_deed"
                            ? "سند ملكية الأرض"
                            : doc.type === "cost_calculation_form"
                            ? "نموزج حساب التكاليف"
                            : doc.type === "insurance_policy"
                            ? "وثيقة تأمين "
                            : doc.type === "business_validity_certificate"
                            ? "شهادة صلاحية الأعمال للتراخيص موقعة من المهندس"
                            : doc.type ===
                              "insurance_document_construction_drawings"
                            ? "وثيقة تأمين بها نسبة من الرسومات الأنشائية معتمدة من المحطة العشرية"
                            : doc.type === "detect_recorders"
                            ? "كشف مسجلات لأكثر من عامين"
                            : doc.type === "property_picture"
                            ? "صورة للعقار"
                            : doc.type === "tax_certificate"
                            ? "شهادة من مأمورية الضرائب"
                            : doc.type ===
                              "final_decision_administrative_authority_demolish"
                            ? "قرار نهائي من الجهة الأدارية بالهدم"
                            : doc.type === "elevator_installation_contract"
                            ? "عقد تركيب المصعد من احد الشركات مع صورة من تصريح مزاولة المهنة "
                            : doc.type ===
                              "elevator_company_registration_classification_card"
                            ? "صورة من بطاقة قيد وتصنيف شركة المصاعد بالأتحاد المصري لمقاولي التنفيذ والبناء"
                            : doc.type ===
                              "technical_engineering_specifications_file"
                            ? "ملف الموصفات الفنية والرسومات الهندسية"
                            : doc.type === "assessment_includes_business"
                            ? "مقاييس تتضمن الأعمال"
                            : doc.type === "arithmetic_note"
                            ? "نوتة حسابية من مكتب المهندس"
                            : doc.type === "structural_engineer_report"
                            ? "تقرير مهندس انشائي "
                            : doc.type === "license_application"
                            ? "طلب الترخيص"
                            : doc.type === "lease"
                            ? "صورة من مستند الايجار ساري لمدة مناسبة وموضح النشاط"
                            : doc.type === "ownership_contract"
                            ? "صورة من مستند الملكية ساري لمدة مناسبة وموضح النشاط"
                            : doc.type === "construction_license"
                            ? "صورة من رخصة البناء"
                            : doc.type === "organization_benefit_store_position"
                            ? "افادة من التنظيم بموقف المحل (رخصة - تقنين)"
                            : doc.type ===
                              "real_estate_transactions_certificate"
                            ? "شهادة تصرف عقاري"
                            : doc.type === "certified_engineering_report"
                            ? "تقرير هندسي معتمد يثبت السلامة الأنشائية"
                            : doc.type === "sketch_showing_location"
                            ? "الرسم الكروكي"
                            : doc.type === "power_attoreny"
                            ? "التوكيل"
                            : doc.type === "original_license"
                            ? "اصل الرخصة"
                            : doc.type === "payment_receipt"
                            ? "إيصال الدفع"
                            : doc.type === "criminal_record"
                            ? "صحيفة الحالة الجنائية"
                            : doc.type === "assignment_contract"
                            ? "عقد التنازل ومصدق من الشهر العقاري"
                            : doc.type === "benefits_assignee_insurance"
                            ? "ما يفيد المتنازل الية بالتأمينات"
                            : doc.type === "military_service"
                            ? "الموقف من التجنيد"
                            : doc.type ===
                              "construction_drawings_advertising_stands"
                            ? "نسختان من الرسومات الأنشائية للحوامل بالأعلان"
                            : doc.type ===
                              "drawings_electrical_installations_connections"
                            ? "نسختان من الرسومات للتركيبات و للتوصيلات الكهربائية "
                            : doc.type === "passport"
                            ? "جواز السفر"
                            : doc.type === "engineering_drawings"
                            ? "الرسومات الهندسية"
                            : doc.type === "client_national_id"
                            ? "البطاقة الشخصية"
                            : doc.type === "health_certificate_employees"
                            ? "شهادة صحية لجميع العاملين"
                            : doc.type === "license "
                            ? "الرخصة"
                            : doc.type === "payment_receipt_last_transaction"
                            ? "إيصال سداد لأخر عملية"
                            : doc.type === "commercial_register"
                            ? "سجل تجاري"
                            : doc.type === "industrial_register"
                            ? "سجل صناعي"
                            : doc.type === "collection_letter"
                            ? "خطاب تحصيل"
                            : doc.type === "necessary_costs "
                            ? "سداد التكاليف اللازمة"
                            : doc.type === "insurance_paymen"
                            ? "سداد التأمين"
                            : doc.type === "facilities_receipt"
                            ? "إيصال المرافق"
                            : doc.type === "recored"
                            ? "المحضر"
                            : doc.type ==="assigned_national_identification_number"
                            ? "بطاقة الرقم القومي للمتنازل الية"
                            : doc.type ==="license"
                            ? "الرخصة"
                            : doc.type ==="insurance_payment"
                            ? "إيصال سداد التأمينات"
                            : doc.type ==="necessary_costs"
                            ? "إيصال التكاليف اللازمة"
                            : doc.type === "other"
                            ? "ملفات اخرى"
                            : ""}
                        </button>
                      </p>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ) : null}
          <div className="rounded card w-80 mt-5 bg-light">
            <h3 className="text-center mt-3">حالة الطلب</h3>
            {appdata && appdata.application ? (
              <div className="progress-card w-100 mt-4 mb-5 d-flex flex-column align-items-center">
                <div
                  className="progress rounded-pill d-flex align-items-center justify-content-strart"
                  role="progressbar"
                  aria-label="Example 20px high"
                  aria-valuenow="25"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style={{ width: "80%", height: "25px", position: "relative" }}
                >
                  <div
                    className="progress-bar rounded-pill"
                    style={{
                      width: `${
                        appdata.application.status === 1
                          ? "20%"
                          : appdata.application.status === 2
                          ? "52%"
                          : appdata.application.status === 3
                          ? "100%"
                          : appdata.application.status === 4
                          ? "100%"
                          : appdata.application.status === 5
                          ? "100%"
                          : appdata.application.status === 6
                          ? "100%"
                          : null
                      }`,
                      height: "100%",
                      backgroundColor: "rgb(79,92,146)",
                    }}
                  ></div>
                  <div
                    className="step step-one rounded-circle d-flex justify-content-center align-items-center"
                    style={{
                      backgroundColor: " rgb(169,147,238)",
                      width: "25px",
                      height: "25px",
                    }}
                  >
                    <i className="fa-solid fa-check fa-lg text-light"></i>
                  </div>
                  <div
                    className="step step-two rounded-circle d-flex justify-content-center align-items-center"
                    style={{
                      backgroundColor: " rgb(169,147,238)",
                      width: "25px",
                      height: "25px",
                    }}
                  >
                    <i className="fa-solid fa-check fa-lg text-light"></i>
                  </div>
                  <div
                    className="step step-three rounded-circle d-flex justify-content-center align-items-center"
                    style={{
                      backgroundColor: " rgb(169,147,238)",
                      width: "25px",
                      height: "25px",
                    }}
                  >
                    <i className="fa-solid fa-check fa-lg text-light"></i>
                  </div>
                  <div
                    className="step step-four rounded-circle d-flex justify-content-center align-items-center"
                    style={{
                      backgroundColor: "rgb(169,147,238)",
                      width: "25px",
                      height: "25px",
                    }}
                  ></div>
                </div>
                <div
                  className="mt-4 d-flex flex-row justify-content-between align-items-center"
                  style={{ width: "85%" }}
                >
                  <div className="order-done d-flex flex-column justify-content-between align-items-center">
                    <img src={cel} alt="" style={{ width: "35px" }} />
                    <p className="mt-2">تم الانشاء</p>
                  </div>
                  {appdata && appdata.application ? (
                    appdata.application.status === 2 ? (
                      <div className="revision d-flex flex-column justify-content-between align-items-center">
                        <img src={loc} alt="" style={{ width: "35px" }} />
                        <p className="mt-2">تحت المراجعة</p>
                      </div>
                    ) : null
                  ) : null}
                  {/* <div className="archive">
                          <img src={inn} alt="" style={{width:"35px"}}/>
                      </div>  */}
                  <div className="order-done-or-refused-or-archived d-flex flex-column justify-content-between align-items-center">
                    {appdata && appdata.application ? (
                      appdata.application.status === 3 ? (
                        <>
                          <img src={inn} alt="" style={{ width: "35px" }} />
                          <p className=" mt-2">تمت الأرشفة</p>
                        </>
                      ) : appdata.application.status === 4 ? (
                        <>
                          <img
                            className=""
                            src={ac}
                            alt=""
                            style={{ width: "35px" }}
                          />
                          <p className="mt-2">تمت الموافقة</p>
                        </>
                      ) : appdata.application.status === 5 ? (
                        <>
                          <img src={de} alt="" style={{ width: "35px" }} />
                          <p className="   mt-2">تم رفض الطلب</p>
                        </>
                      )  : appdata.application.status === 6 ? (
                        <>
                          <img src={de} alt="" style={{ width: "35px" }} />
                          <p className="mt-2">تم الأنتهاء </p>
                        </>
                      ) : null
                    ) : null}
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
      <ToastContainer />
      <Modal
        show={Deletesow}
        onHide={handleCloseDelete}
        backdrop="static"
        centered
        keyboard={false}
        contentClassName="cont"
        style={{ width: "100%", margin: "0px auto", textAlign: "center" }}
      >
        <Modal.Header closeButton>
          <Modal.Title>هل تريد حذف الطلب</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {" "}
          <h3 style={{ color: "red" }}>
            في حالة حذف الطلب سيتم تطبيق شروط العقد
          </h3>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            className="close"
            onClick={handleCloseDelete}
          >
            إغلاق
          </Button>
          <Button variant="secondary" className="close" onClick={handleDelete}>
            موافق
          </Button>
        </Modal.Footer>
      </Modal>
      <div className="popimg">
        <Modal
          show={popup}
          onHide={handleClosepopup}
          backdrop="static"
          centered
          keyboard={false}
          contentClassName="cont"
          style={{ width: "100%", margin: "0px auto", textAlign: "center" }}
        >
          <Modal.Header closeButton>
            <Modal.Title>عرض المستند</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {" "}
            {ContentFile.split(".").pop().toLowerCase() === "png" ||
            ContentFile.split(".").pop().toLowerCase() === "jpg" ||
            ContentFile.split(".").pop().toLowerCase() === "jpeg" ||
            ContentFile.split(".").pop().toLowerCase() === "svg" ? (
              <img src={ContentFile} alt="" />
            ) : (
              <Button
                variant="secondary"
                className="close"
                onClick={() =>
                  handleDownload(
                    ContentFile,
                    `document.${ContentFile.split(".").pop().toLowerCase()}`
                  )
                }
              >
                تحميل ملف بصيغة {ContentFile.split(".").pop().toLowerCase()}{" "}
                <i className="fa-solid fa-file-export"></i>
              </Button>
            )}
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              className="close"
              onClick={handleClosepopup}
            >
              إغلاق
            </Button>
            {ContentFile.split(".").pop().toLowerCase() === "png" ||
            ContentFile.split(".").pop().toLowerCase() === "jpg" ||
            ContentFile.split(".").pop().toLowerCase() === "jpeg" ||
            ContentFile.split(".").pop().toLowerCase() === "svg" ? (
              <Button
                variant="secondary"
                className="close"
                onClick={() =>
                  handleDownload(
                    ContentFile,
                    `document.${ContentFile.split(".").pop().toLowerCase()}`
                  )
                }
                // onClick={() =>
                //   downloadFile({ url: ContentFile, filename: "newfile.png" })
                // }
              >
                تحميل الصورة
              </Button>
            ) : null}
            {/* <a  href={ContentFile}  className="close" >
            تحميل الملف
          </a> */}
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
};

export default Requetsuserdetails;
